<template>
    <div class="components-container">
        <!-- 按钮区域 -->
        <div class="filter-container">
            <el-select v-model="queryForm.jpXn" placeholder="起效学年" style="width: 200px" clearable>
                <el-option v-for="(item, index) in year" :key="item.comboValue" :label="item.comboName"
                           :value="item.comboValue">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.jpZydm" @keyup.enter.native="handleFilter" @change="changeMajor" style="width: 200px"
                      placeholder="专业名称" clearable>
            </el-input>
            <!--
            <el-select v-model="queryForm.jpMsdm" placeholder="教学模式" style="width: 200px" clearable>
                <el-option v-for="(item, index) in teachMode" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            -->
            <el-select v-model="queryForm.jpShzt" placeholder="审核状态" style="width: 200px" clearable>
                <el-option v-for="(item, index) in status" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询
            </el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;新建</el-button>
            <!-- <el-button @click="showDialog('edit')" type="warning"><i class="el-icon-edit"></i>&nbsp;编辑</el-button> -->
            <!-- <el-button @click="showDialog('delete')" type="danger"><i class="el-icon-delete"></i>&nbsp;删除</el-button> -->
            <el-button v-if="ggkAuth!='0'" type="warning" @click="pubCourseConfig"><i class="el-icon-setting"></i>&nbsp;公共课设置
            </el-button>
            <el-button type="primary" @click="showDialog('mduplicate')"><i class="el-icon-document-copy"></i>&nbsp;批量复制
            </el-button>
            <!-- <el-button type="primary" @click="syncData"><i class="el-icon-sort"></i>&nbsp;数据同步</el-button> -->
            <!-- <el-button v-if="syncDataVisible" @click="syncSchemeData" type="primary"><i class="el-icon-refresh"></i>&nbsp;同步人培方案信息</el-button> -->
            <el-button @click="exportDialogVisible = true" type="primary"><i class="el-icon-download"></i>&nbsp;课程设置导出
            </el-button>
        </div>

        <!-- 列表区域 -->
        <div v-loading="downloading" element-loading-text="导出中">
            <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
                      :cell-style="handleCellStyle" :header-cell-style="{'background-color':'#f1faf6'}"
                      element-loading-text="信息加载中" highlight-current-row border fit:false style="width: 100%"
                      :height="mainTableHeight" ref="mainTable">
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{ (currentPage - 1) * queryForm.limit + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="编号" prop="jpBh" align="center" v-if="isShow"></el-table-column>
                <el-table-column label="起效学年" prop="jpXn" align="center" min-width="10%"></el-table-column>
                <el-table-column label="专业名称（代码）" prop="fullName" align="center" min-width="20%"></el-table-column>
                <el-table-column label="国标专业名称（代码）" prop="standardName" align="center" min-width="20%"></el-table-column>
                <el-table-column label="学制" prop="institution" align="center" min-width="10%"></el-table-column>
                <el-table-column label="指定班级" prop="jpGlbjmc" align="center" min-width="20%"></el-table-column>
                <!-- <el-table-column label="专业代码" prop="jpBydm" align="center" v-if="isShow"></el-table-column> -->
                <!-- <el-table-column label="专业别名" prop="jpZybm" align="center" min-width="20%"></el-table-column> -->
                <!-- <el-table-column label="教学模式" prop="msmc" align="center" min-width="10%"></el-table-column> -->
                <el-table-column label="提交状态" prop="jpTjzt" :formatter="submitStateFormatter" align="center" min-width="10%"></el-table-column>
                <el-table-column label="审核状态" prop="jpShzt" :formatter="auditStateFormatter" align="center" min-width="10%">
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="20%">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.jpTjzt == '0'" size="small" @click="modRec(scope.row);" type="warning">
                            <i class="el-icon-edit"></i>&nbsp;编辑
                        </el-button>
                        <el-button v-if="scope.row.jpTjzt == '0'" size="small" @click="delRec(scope.row);" type="danger">
                            <i class="el-icon-delete"></i>&nbsp;删除
                        </el-button>
                        <el-button v-if="scope.row.jpTjzt=='1' && scope.row.auditAuth=='0'" size="small" @click="showRec(scope.row);" type="info">
                            <i class="el-icon-tickets"></i>&nbsp;详情
                        </el-button>
                        <el-button v-if="scope.row.auditAuth == '1'" size="small" @click="auditRec(scope.row);" type="primary">
                            <i class="el-icon-edit-outline"></i>&nbsp;审核
                        </el-button>
                        <el-button v-if="scope.row.jpTjzt=='1' || scope.row.jpShzt!=''" size="small" @click="showAuditList(scope.row);">
                            <i class="el-icon-document-copy"></i>&nbsp;审核信息
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 列表分页 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                           :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="queryForm.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 人培新建对话框 -->
        <el-dialog title="新建" :visible.sync="createDialogVisivle" width="600px" top="200px" @closed="closeCreateDialog" append-to-body>
            <el-form ref="createForm" :model="createForm" label-width="120px" label-position="left" :rules="createFormRules">
                <el-form-item label="起效学年" prop="workYear">
                    <el-select v-model="createForm.workYear" placeholder="请选择起效学年" style="width:100%;" @change="yearChange">
                        <el-option v-for="(item, index) in year" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="专业名称" prop="majorCode">
                    <el-select v-model="createForm.majorCode" placeholder="请选择专业" style="width:100%;" @change="majorChange" filterable>
                        <el-option v-for="(item, index) in majorComboOption" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学制" prop="learnYear">
                    {{ createForm.learnYear }}
                    <!-- <el-input-number v-model="createForm.learnYear" style="width:100%;" :min="0" :precision="1" :step="0.5" placeholder="请输入学制">
                    </el-input-number> -->
                </el-form-item>
                <el-form-item label="指定班级" prop="glbjbh">
                    <el-select v-model="createForm.glbjbh" placeholder="请选择指定班级" style="width:100%;" multiple>
                        <el-option v-for="(item, index) in createClassInfo" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" @click="createTeachingScheme">保存</el-button>
                <el-button @click="createDialogVisivle = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 人培设置对话框 -->
        <el-dialog :title="schemeDialogTitle" custom-class="teachingSchemeSetDialog" :visible.sync="schemeDialogVisivle" @closed="closeSchemeDialog" :fullscreen="true">
            <!-- 遮罩层 -->
            <div id="loadingMask" class="maskStyle">
                <div class="maskFont">人才培养方案加载中，请稍候...</div>
            </div>
            <div slot="title">
                <el-row>
                    <el-col :span="23" style="text-align: right">
                        <!-- <el-button @click="singleExport" type="success">导出</el-button> -->
                        <el-button @click="templetDownload" type="gray">教学进程表模板下载</el-button>
                        <el-button @click="importCAP()" type="success"><i>教学进程表导入</i></el-button>
                        <el-button @click="exportCAP()" type="primary"><i>教学进程表导出</i></el-button>
                        <el-button @click="importPubCourse" type="success" v-show="importButtonVisible" :disabled="editDisableState">公共课导入</el-button>
                        <el-button @click="statisticCAP()" type="warning"><i>课程类型统计</i></el-button>
                        <el-button @click="showDialog('sduplicate')" type="primary">复制</el-button>
                        <!-- <el-button @click="inhertZYK()" type="primary">继承专业课</el-button> -->
                        <el-button v-if="auditState=='1' " @click="changeRec" type="warning">变更教学进程</el-button>
                    </el-col>
                    <el-col :span="1"></el-col>
                </el-row>
            </div>
            <div :style="innerDialog" class="scrollArea">
                <el-scrollbar style="height: 100%;" ref="elScrollbar">
                    <div class="titles" style="text-align:center; height:60px; line-height:60px; font-size:24px; font-weight:bold;">
                        人才培养方案
                    </div>
                    <el-row>
                        <teaching-form :key="timer" ref="teachingForm" @loadParams="loadParams" :isEdit="isEdit" :editDisableState="editDisableState" :classInfo="classInfo">
                        </teaching-form>
                    </el-row>
                    <el-row>
                        <occupation-scope ref="occupation" :editDisableState="editDisableState" @changeEditRow="changeEditRow">
                        </occupation-scope>
                    </el-row>
                    <el-row>
                        <talent ref="talent" :editDisableState="editDisableState" @changeEditRow="changeEditRow"></talent>
                    </el-row>
                    <el-row>
                        <teaching-weeks @transweeks="transweeks" @changeArrange="changeArrange" ref="teachingWeeks" :editDisableState="editDisableState" :xz="xz"></teaching-weeks>
                    </el-row>
                    <!-- <el-row>
                        <course ref="course"  @changeindexs="changeindexs" v-on:combineprogress="combineprogress" @openWindow="openWindow"
                            :publicCourse="publicCourse"
                            :majorCoreCourse="majorCoreCourse"
                            :majorSkillCourse="majorSkillCourse"
                            :trainingCourse="trainingCourse"
                            :electiveCourse="electiveCourse"
                            :state="state"
                        ></course>
                    </el-row> -->
                    <el-row>
                        <CAP ref="CAP" :courseComboInfo="courseComboInfo" :editDisableState="editDisableState" :xz="xz" @changeEditRow="changeEditRow" @openWindow="openWindow"></CAP>
                    </el-row>
                    <el-row>
                        <teaching-arrangement ref="arrangement" :editDisableState="editDisableState" @changeEditRow="changeEditRow">
                        </teaching-arrangement>
                    </el-row>
                    <!-- <el-row>
                        <teaching-progress :progress="progress" :state="state" ref="progress" @progresstocourse="progresstocourse" @changeEditRow="changeEditRow"
                        ></teaching-progress>
                    </el-row> -->
                    <el-row>
                        <graduateRequire :editDisableState="editDisableState" :courseAttr="kcsxInfo" :etype="etype" ref="graduateRequire"></graduateRequire>
                    </el-row>
                    <el-row>
                        <comment :editDisableState="editDisableState" :filelist="filelist" :etype="etype" ref="comment"></comment>
                    </el-row>
                </el-scrollbar>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="formSubmiting" @click="saveScheme('save')" v-show="saveButtonVisible" :disabled="editDisableState">保 存</el-button>
                <el-button type="warning" :loading="formSubmiting" @click="submitWapper" v-show="submitButtonVisible" :disabled="editDisableState">提 交</el-button>
                <el-button type="danger" :loading="formSubmiting" @click="showAuditDialog" v-show="auditButtonVisible">审 核</el-button>
            </div>
        </el-dialog>

        <!-- 教学进程表变更信息 -->
        <el-dialog :title="'教学进程表变更信息'" width="1200px" top="90px" :visible.sync="editSchemeDialogVisivle" @closed="closeEditSchemeDialog" append-to-body>
            <div class="filter-container">
                <!-- <el-select v-model="queryJxjcForm.jjXn" placeholder="起效学年" style="width: 150px" clearable>
                    <el-option v-for="(item, index) in year" :key="item.comboValue" :label="item.comboName"
                        :value="item.comboValue">
                    </el-option>
                </el-select>
                <el-select v-model="queryJxjcForm.jjShzt" placeholder="审核状态" style="width: 150px" clearable>
                    <el-option v-for="(item, index) in status" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                    </el-option>
                </el-select> -->
                <!-- <el-button @click="handleFilter_editScheme" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
                <el-button @click="handleReset_editScheme" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button> -->
                <el-button @click="addJxjc" type="success" style="margin-left: 0px"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加教学进程</el-button>
                <el-button @click="editJxjc" type="warning" style="margin-left: 10px"><i class="el-icon-edit"></i>&nbsp;修改教学进程</el-button>
                <el-button @click="delJxjc" type="danger" style="margin-left: 10px"><i class="el-icon-delete"></i>&nbsp;删除教学进程</el-button>
            </div>

            <el-table :data="editSchemeData" v-loading.body="tableLoading" @row-click="rowClick_editScheme" style="width: 100%" :cell-style="handleCellStyle_jxjc"
                      element-loading-text="信息加载中" highlight-current-row border :height="editSchemeTableHeight" ref="editSchemeTable">
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{ (currentPage_editScheme - 1) * limit_editScheme + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="学年" prop="jjXn" align="center" min-width="6%"></el-table-column>
                <el-table-column label="专业" prop="jjZymc" align="center" min-width="25%"></el-table-column>
                <el-table-column label="课程代码" prop="jjKcdm" align="center" min-width="10%"></el-table-column>
                <el-table-column label="课程名称" prop="jjKcmc" align="center" min-width="20%"></el-table-column>
                <el-table-column label="变更类型" prop="jjBglxmc" align="center" min-width="10%"></el-table-column>
                <el-table-column label="提交状态" prop="jjTjzt" :formatter="submitStateFormatter_editscheme" align="center" min-width="10%"></el-table-column>
                <!-- <el-table-column label="审核状态" prop="jjShzt" :formatter="auditStateFormatter_editscheme" align="center" min-width="10%"></el-table-column> -->
                <el-table-column label="操作" align="center" width="220px">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.jjTjzt=='0'" size="small" @click="modRec_jxjc(scope.row);" type="warning">
                            <i class="el-icon-edit"></i>&nbsp;编辑
                        </el-button>
                        <el-button v-if="scope.row.jjTjzt == '0'" size="small" @click="delRec_jxjc(scope.row);" type="danger">
                            <i class="el-icon-delete"></i>&nbsp;删除
                        </el-button>
                        <el-button v-if="scope.row.jjTjzt=='1'" size="small" @click="showRec_jxjc(scope.row);" type="info">
                            <i class="el-icon-tickets"></i>&nbsp;详情
                        </el-button>
                        <!-- <el-button v-if="scope.row.auditAuth == '1'" size="small" @click="auditRec_jxjc(scope.row);" type="primary">
                            <i class="el-icon-edit-outline"></i>&nbsp;审核
                        </el-button>
                        <el-button v-if="scope.row.jjTjzt=='1' || scope.row.jjShzt!=''" size="small" @click="showAuditList_jxjc(scope.row);">
                            <i class="el-icon-document-copy"></i>&nbsp;审核信息
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange_editScheme" @current-change="handlePageChange_editScheme"
                               :current-page.sync="currentPage_editScheme" :page-sizes="[10, 20, 50]" :page-size="limit_editScheme"
                               layout="total, sizes, prev, pager, next, jumper" :total="total_editScheme"></el-pagination>
            </div>
        </el-dialog>

        <!-- 新建编辑删除教学进程表 -->
        <el-dialog :title="jxjcTitle" :visible.sync="jxjcDialogVisible" @closed="closeJxjcDialog" width="1662px" :top="jxjcHeight" :close-on-click-modal="false" append-to-body>
            <el-form class="small-space" :model="jxjcForm" ref="jxjcForm" label-position="left" label-width="100px" style='width: 100%; margin-left:0px;'>
                <el-row class="elrowStyle">
                    <el-col :span="6" class="row-label">
                        <el-form-item label="学年" prop="jjXn">
                            {{ jxjcForm.jjXn + '学年' }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="专业名称" prop="jjZymc">
                            {{ jxjcForm.jjZymc }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item v-if="(jxjcTitle=='修改教学进程' || jxjcTitle=='删除教学进程') && jxjcForm.saveType!='show'" label="原课程" prop="jjJxjckcmc">
                            <el-input v-model="jxjcForm.jjJxjckcmc" placeholder="请选择原课程" @focus="openScheme"></el-input>
                        </el-form-item>
                        <el-form-item v-if="jxjcForm.jjBglx!='1' && jxjcForm.saveType=='show'" label="原课程" prop="jjJxjckcmc">
                            {{ jxjcForm.jjJxjckcmc }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 编辑或删除显示内容 -->
                <el-row class="elrowStyle" v-if="jxjcTitle == '修改教学进程' || jxjcTitle == '删除教学进程'">
                    <el-col :span="6" class="row-label">
                        <el-form-item label="原课程信息:">
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程类别" prop="jjKcsx">
                            <div>{{ oldJxjcForm[0].jjKclxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程性质" prop="jjKcsx">
                            <div>{{ oldJxjcForm[0].jjKcsxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程名称" prop="jjKcdm">
                            <div>{{ oldJxjcForm[0].jjKcmc }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="jxjcTitle == '修改教学进程' || jxjcTitle == '删除教学进程'">
                    <el-table
                        :data="oldJxjcForm"
                        ref="CAPTable"
                        :header-cell-style="{'text-align':'center','blackground-color':'#f1faf6'}"
                        element-loading-text="信息加载中"
                        border
                        class="tb-edit"
                        fit
                        highlight-current-row
                        style="width: 1622px"
                        height="137px"
                        :row-style="{ 'height':'64px' }"
                    >
                        <el-table-column label="学分" width="70" align="center" prop="score">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXf }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="总学时" width="70" align="center" prop="totalTime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjZxs }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'理论\n教学'" width="70" prop="theoryTime" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjLljx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'实验\n实训'" width="70" prop="practiseTime" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjSysx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否专业\n核心课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.isMajorcoreName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否考证\n课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.isCertificateName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="考核方式" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjKhfsmc }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="一" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq1, scope.row.jjZs1) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="二" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq2, scope.row.jjZs2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="三" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq3, scope.row.jjZs3) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="四" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq4, scope.row.jjZs4) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="五" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq5, scope.row.jjZs5) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="六" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq6, scope.row.jjZs6) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="七" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq7, scope.row.jjZs7) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="八" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq8, scope.row.jjZs8) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="九" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq9, scope.row.jjZs9) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="十" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq10, scope.row.jjZs10) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjBz }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <!-- 编辑修改内容 -->
                <el-row class="elrowStyle" v-if="jxjcTitle == '添加教学进程' || jxjcTitle == '修改教学进程'">
                    <el-col :span="6" class="row-label" v-if="jxjcTitle == '修改教学进程'">
                        <el-form-item label="新课程信息:">
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程类别" prop="jjKclx">
                            <el-select v-show="this.jxjcShow != 'show'" v-model="editJxjcForm[0].jjKclx" placeholder="请选择课程类别" class="input-full" @change="coursePropertiesChange" filterable>
                                <el-option v-for="(item, index) in kclxInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                            <div v-show="this.jxjcShow == 'show'">{{ editJxjcForm[0].jjKclxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程性质" prop="jjKcsx">
                            <el-select v-show="this.jxjcShow != 'show'" v-model="editJxjcForm[0].jjKcsx"
                                       :placeholder="kcsxholder" :disabled="kcsxDisabled"
                                       class="input-full" filterable>
                                <el-option v-for="(item, index) in kcsxInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                            <div v-show="this.jxjcShow == 'show'">{{ editJxjcForm[0].jjKcsxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程名称" prop="jjKcdm">
                            <el-select v-show="this.jxjcShow != 'show'" v-model="editJxjcForm[0].jjKcdm" placeholder="请选择课程" class="input-full" @change="courseInfoChange" filterable>
                                <el-option v-for="(item, index) in courseInfo" :key="item.jjKcdm" :label="item.courseName" :value="item.jjKcdm">
                                </el-option>
                            </el-select>
                            <div v-show="this.jxjcShow == 'show'">{{ editJxjcForm[0].jjKcmc }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="elrowStyle" v-if="jxjcTitle == '添加教学进程' || jxjcTitle == '修改教学进程'">
                    <el-table
                        :data="editJxjcForm"
                        ref="CAPTable"
                        :header-cell-style="{'text-align':'center','blackground-color':'#f1faf6'}"
                        element-loading-text="信息加载中"
                        border
                        class="tb-edit"
                        fit
                        highlight-current-row
                        style="width: 1622px"
                        height="183px"
                        :row-style="{ 'height':'64px' }"
                    >
                        <el-table-column label="学分" width="70" align="center" prop="score">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input-number v-model="scope.row.jjXf"
                                                     style="width: 50px"
                                                     :controls="false"
                                                     size="mini"
                                                     :min="0"
                                    ></el-input-number>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.jjXf }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="总学时" width="70" align="center" prop="totalTime">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input-number v-model="scope.row.jjZxs"
                                                     :controls="false"
                                                     style="width: 50px"
                                                     size="mini"
                                                     :min="0"
                                    ></el-input-number>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.jjZxs }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'理论\n教学'" width="70" prop="theoryTime" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input-number v-model.number="scope.row.jjLljx"
                                                     class="numbers"
                                                     controls-position="right"
                                                     :max="1000"
                                                     size="mini"
                                                     style="width: 50px"
                                                     :step="1"
                                                     :step-strictly="true"
                                                     :min="0"
                                                     :controls="false"
                                    ></el-input-number>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.jjLljx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'实验\n实训'" width="70" prop="practiseTime" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input-number v-model.number="scope.row.jjSysx"
                                                     class="numbers"
                                                     controls-position="right"
                                                     :max="1000"
                                                     size="mini"
                                                     style="width: 50px"
                                                     :step="1"
                                                     :min="0"
                                                     :step-strictly="true"
                                                     :controls="false"
                                    ></el-input-number>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.jjSysx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否专业\n核心课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-select v-model="scope.row.isMajorcore" placeholder="" @change="handleMajorcoreChange(scope)">
                                        <el-option v-for="(item, index) in sfzt"
                                                   :key="index"
                                                   :label="item.comboName"
                                                   :value="item.comboValue"
                                        ></el-option>
                                    </el-select>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.isMajorcore }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否考证\n课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-select v-model="scope.row.isCertificate" placeholder="" @change="handleCertificateChange(scope)">
                                        <el-option v-for="(item, index) in sfzt"
                                                   :key="index"
                                                   :label="item.comboName"
                                                   :value="item.comboValue"
                                        ></el-option>
                                    </el-select>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.isCertificate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="考核方式" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-select v-model="scope.row.jjKhfs" placeholder="" @change="handleExamTypeChange(scope)">
                                        <el-option v-for="(item, index) in assessFormInfo"
                                                   :key="index"
                                                   :label="item.comboName"
                                                   :value="item.comboValue"
                                        ></el-option>
                                    </el-select>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.jjKhfsmc }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="一" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq1" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs1" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq1,scope.row.jjZs1) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="二" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq2" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs2" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq2,scope.row.jjZs2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="三" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq3" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs3" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq3,scope.row.jjZs3) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="四" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq4" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs4" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq4,scope.row.jjZs4) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="五" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq5" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs5" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq5,scope.row.jjZs5) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="六" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq6" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs6" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq6,scope.row.jjZs6) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="七" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq7" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs7" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq7,scope.row.jjZs7) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="八" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq8" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs8" style="width:90px; margin-top:5px;" maxlength="100"
                                        oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq8,scope.row.jjZs8) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="九" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq9" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs9" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq9,scope.row.jjZs9) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="十" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.jjXq10" style="width:90px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">学时</template>
                                    </el-input>
                                    <el-input v-model="scope.row.jjZs10" style="width:90px; margin-top:5px;" maxlength="100"
                                              oninput="value=value.replace(/[^\d]/g,'')">
                                        <template slot="append" style="padding:0px;">周</template>
                                    </el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ formatterNumHour(scope.row.jjXq10,scope.row.jjZs10) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="el-edit" v-show="this.jxjcShow != 'show'">
                                    <el-input v-model="scope.row.bz" placeholder=""></el-input>
                                </span>
                                <span v-show="this.jxjcShow == 'show'">{{ scope.row.jjBz }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="editJxjcForm[0].saveType=='new' || editJxjcForm[0].saveType=='edit'" type="primary" :loading="formSubmiting" @click="saveJxjcbg('save')">保 存</el-button>
                <el-button v-if="editJxjcForm[0].saveType=='new' || editJxjcForm[0].saveType=='edit'" type="warning" :loading="formSubmiting" @click="submitJxjcbg">提 交</el-button>
                <el-button v-if="editJxjcForm[0].saveType=='audit'" type="danger" :loading="formSubmiting" @click="auditOption();">审 核</el-button>
                <el-button v-if="editJxjcForm[0].saveType!='show'" @click="closeJxjcDialog">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 显示教学进程变更 编辑详情 -->
        <el-dialog :title="jxjcTitle" :visible.sync="jxjcCompareDialogVisible" @closed="closeCompareJxjcDialog" width="1662px" top="80px" :close-on-click-modal="false" append-to-body>
            <el-form class="small-space" :model="jxjcForm" :rules="jxjcRule" ref="jxjcForm" label-position="left" label-width="100px" style='width: 100%; margin-left:0px;'>
                <el-row class="elrowStyle">
                    <el-col :span="5" class="row-label">
                        <el-form-item label="学年" prop="jjXn">
                            {{ jxjcForm.jjXn + '学年' }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="row-label">
                        <el-form-item label="专业名称" prop="jjZymc">
                            {{ jxjcForm.jjZymc }}
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="elrowStyle" v-if="jxjcForm.jjBglx=='2'">
                    <el-col :span="6" class="row-label">
                        <el-form-item label="原课程信息:">
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程类别" prop="jjKcsx">
                            <div>{{ oldJxjcForm[0].jjKclxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程性质" prop="jjKcsx">
                            <div>{{ oldJxjcForm[0].jjKcsxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程名称" prop="jjKcdm">
                            <div>{{ oldJxjcForm[0].jjKcmc }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-if="jxjcForm.jjBglx=='2'">
                    <el-table
                        :data="oldJxjcForm"
                        ref="CAPTable"
                        :header-cell-style="{'text-align':'center','blackground-color':'#f1faf6'}"
                        element-loading-text="信息加载中"
                        border
                        class="tb-edit"
                        fit
                        highlight-current-row
                        style="width: 1622px"
                        height="137px"
                        :row-style="{ 'height':'64px' }"
                    >
                        <el-table-column label="学分" width="70" align="center" prop="score">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXf }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="总学时" width="70" align="center" prop="totalTime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjZxs }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="理论教学" width="70" prop="theoryTime" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjLljx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实验实训" width="70" prop="practiseTime" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjSysx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否专业\n核心课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.isMajorcore }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否考证\n课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.isCertificate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="考核方式" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjKhfsmc }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="一" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq1, scope.row.jjZs1) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="二" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq2, scope.row.jjZs2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="三" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq3, scope.row.jjZs3) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="四" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq4, scope.row.jjZs4) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="五" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq5, scope.row.jjZs5) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="六" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq6, scope.row.jjZs6) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="七" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq7, scope.row.jjZs7) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="八" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq8, scope.row.jjZs8) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="九" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq9, scope.row.jjZs9) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="十" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.jjXq10, scope.row.jjZs10) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjBz }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>

                <el-row class="elrowStyle">
                    <el-col :span="6" class="row-label">
                        <el-form-item v-if="jxjcForm.jjBglx=='2'" label="新课程信息:"></el-form-item>
                        <el-form-item v-if="jxjcForm.jjBglx!='2'" label="课程信息:"></el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程类别" prop="jjKclx">
                            <el-select v-show="this.jxjcShow != 'show'" v-model="newJxjcForm.jjKclx" placeholder="请选择课程类别" class="input-full" @change="coursePropertiesChange" filterable>
                                <el-option v-for="(item, index) in kclxInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                            <div v-show="this.jxjcShow == 'show'">{{ newJxjcForm[0].jjKclxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程属性" prop="jjKcsx">
                            <el-select v-show="this.jxjcShow != 'show'" v-model="newJxjcForm.jjKcsx" placeholder="请选择课程属性" class="input-full" @change="coursePropertiesChange" filterable>
                                <el-option v-for="(item, index) in kcsxInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                            <div v-show="this.jxjcShow == 'show'">{{ newJxjcForm[0].jjKcsxmc }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="row-label">
                        <el-form-item label="课程名称" prop="jjKcdm">
                            <el-select v-show="this.jxjcShow != 'show'" v-model="newJxjcForm.jjKcdm" placeholder="请选择课程" class="input-full" @change="courseInfoChange" filterable>
                                <el-option v-for="(item, index) in courseInfo" :key="item.jjKcdm" :label="item.courseName" :value="item.jjKcdm">
                                </el-option>
                            </el-select>
                            <div v-show="this.jxjcShow == 'show'">{{ newJxjcForm[0].jjKcmc }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-table
                        :data="newJxjcForm"
                        ref="CAPTable"
                        :header-cell-style="{'text-align':'center','blackground-color':'#f1faf6'}"
                        element-loading-text="信息加载中"
                        border
                        class="tb-edit"
                        fit
                        highlight-current-row
                        style="width: 1622px"
                        height="137px"
                        :row-style="{ 'height':'64px' }"
                    >
                        <el-table-column label="学分" width="70" align="center" prop="score">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXf }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="总学时" width="70" align="center" prop="totalTime">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjZxs }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="理论教学" width="70" prop="theoryTime" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjLljx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实验实训" width="70" prop="practiseTime" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjSysx }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否专业\n核心课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.isMajorcore }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="'是否考证\n课程'" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.isCertificate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="考核方式" width="80" prop="examType" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjKhfsmc }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="一" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="二" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq2 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="三" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq3 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="四" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq4 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="五" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq5 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="六" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq6 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="七" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq7 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="八" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq8 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="九" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq9 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="十" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjXq10 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" width="100" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jjBz }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>

                <el-row>
                    <div style="height:20px;"></div>
                </el-row>
            </el-form>
        </el-dialog>

        <!-- 显示教学进程表 -->
        <el-dialog title="教学进程表" custom-class="teachingSchemeSetDialog" width="1860px" top="60px"
                   :visible.sync="showSchemeDialogVisivle" @closed="closeShowSchemeDialog">
            <!-- 遮罩层 -->
            <div id="loadingMask_edit" class="maskStyle" style="z-index:99999;">
                <div class="maskFont">教学进程表加载中，请稍候...</div>
            </div>
            <div style="height: 750px;margin-top:20px;">
                <div class="titles" style="text-align:center; height:60px; line-height:60px; font-size:24px; font-weight:bold;">
                    {{ queryForm.jpXn + '学年 ' + jpZymc }} 教学进程表
                </div>
                <el-row>
                    <editCAP ref="editCAP" :courseComboInfo="courseComboInfo" :editDisableState="editDisableState" @changeEditRow="changeEditRow"
                             @getJxjcInfo="getJxjcInfo" @closeJxjcInfoDialog="closeJxjcInfoDialog"></editCAP>
                </el-row>
            </div>
        </el-dialog>

        <el-dialog title="复制" :visible.sync="sduplicateDialogVisible" width="600px" top="300px">
            <el-form :model="sduplicateForm" ref="sduplicateForm" label-width="120px" label-position="left" width="100%"
                     :rules="sduplicateRules">
                <el-row>
                    <el-form-item label="复制方案" prop="sorigin">
                        <el-select style="width: 400px" v-model="sduplicateForm.sorigin" placeholder="请选择目标方案" filterable>
                            <el-option v-for="item in sorigins" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="目标学年" prop="starget">
                        <el-select v-model="sduplicateForm.starget" placeholder="请选择目标学年" style="width:400px;">
                            <el-option v-for="item in year" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sduplicate()" type="primary">确 定</el-button>
                <el-button @click="sduplicateDialogCancel">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量复制" :visible.sync="mduplicateDialogVisible" width="550px" top="250px">
            <el-form :model="mduplicateForm" ref="mduplicateForm" label-width="130px" label-position="left" width="100%" :rules="mduplicateRules">
                <el-row>
                    <el-form-item label="复制学年" prop="morigin">
                        <el-select style="width: 350px" v-model="mduplicateForm.morigin" placeholder="请选择起始学年" @change="hanleMoriginChange">
                            <el-option v-for="item in year" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="目标学年" prop="mtarget">
                        <el-select v-model="mduplicateForm.mtarget" placeholder="请选择目标学年" style="width: 350px">
                            <el-option v-for="item in year" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="专业名称" prop="majors">
                        <el-select style="width: 350px" v-model="mduplicateForm.majors" placeholder="请选择专业（不选默认复制全部专业）" multiple>
                            <el-option v-for="item in majors" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="mduplicate()" type="primary">确 定</el-button>
                <el-button @click="mduplicateDialogCancel">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="审核" :visible.sync="auditDialogVisible" v-if="auditDialogVisible" width="900px" top="300px">
            <el-row>
                <el-col :span="24">
                    <audit ref="audit" :itemCode="auditParam" :relatedCode="selectRowData.jpBh" :auditLevel="selectRowData.auditLevel" @auditCallback="auditCallback"></audit>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="900px" top="150px">
            <div style="height:550px;">
                <auditList ref="auditList" :relatedCode="selectRowData.jpBh" :listHeight="450" :auditFlowInfo="auditFlowInfo"></auditList>
            </div>
        </el-dialog>

        <el-dialog title="公共课设置" :visible.sync="coursePreConfigDialogVisible" v-if="coursePreConfigDialogVisible" width="1300px" top="50px" append-to-body>
            <div style="height:700px;">
                <coursePreConfig ref="coursePreConfig" :listHeight="600"></coursePreConfig>
            </div>
        </el-dialog>

        <el-dialog :title="courseImportDialogTitle" :visible.sync="courseImportDialogVisible" v-if="courseImportDialogVisible" width="1100px" top="100px" append-to-body>
            <div style="height:600px;">
                <courseImport ref="courseImport" :listHeight="520" @refreshInfo="refreshInfo" @closeImportPubCourseDialog="closeImportPubCourseDialog"></courseImport>
            </div>
        </el-dialog>

        <el-dialog title="导出" :visible.sync="exportDialogVisible" top="150px" v-on:close="exportDialogVisibleClose">
            <el-form ref="exportForm" :model="exportForm" label-width="80px">
                <el-form-item label="学年" prop="year">
                    <el-select v-model="yearStr" placeholder="全部" style="width: 100%;" clearable>
                        <el-option v-for="(item, index) in year" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属系部" prop="dept">
                    <el-select v-model="dept" multiple placeholder="全部" style="width:100%;" @change="changeDept" clearable>
                        <el-option v-for="(item, index) in comboOption.dept" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属专业" prop="major">
                    <el-select v-model="major" multiple placeholder="全部" style="width: 100%;" clearable>
                        <el-option v-for="(item, index) in comboOption.major" :key="item.comboValue"
                                   :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="fileExport" type="primary">确 定</el-button>
                <el-button @click="exportDialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 导入对话框 -->
        <el-dialog title="导入" :visible.sync="importDialogVisible" width="400px" :top="topHeight" @closed="closeImportDialog"
                   :append-to-body="true" bottom="200px">
            <div id="loadingMask_import" class="maskStyle">
                <div class="maskFont">学分详情查询中，请稍候...</div>
            </div>
            <div class="importDiv">
                <el-upload class="upload-demo" action="#" ref="fileupload" :show-file-list="false" :multiple="false" :auto-upload="true"
                           :http-request="importTeachingProgress" :before-upload="beforeUpload" :limit="100" :on-exceed="handleExceed" drag>
                    <!-- <el-button size="large" type="primary" :loading="fileImporting" style="width:200px; height:50px; margin-top:15px;">
                        {{importButton}}
                        <i class="el-icon-upload el-icon--right"></i>
                    </el-button> -->
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip importTips" slot="tip">仅可导入xls/xlsx文件</div>
                </el-upload>
            </div>
        </el-dialog>

        <!-- 错误信息 -->
        <el-dialog :title="'错误信息'" width="400px" :top="topHeight" :visible.sync="errorDialogVisible" @closed="closeErrorDialog" append-to-body>
            <div class="errorDiv" v-html="errorMessage"></div>
        </el-dialog>

        <el-dialog title="课程类型统计" :visible.sync="progressStatisticsDialogVisible" v-if="progressStatisticsDialogVisible" width="900px" top="110px" append-to-body>
            <div style="height:610px;">
                <progressStatistics ref="progressStatistics" :listHeight="520" :ksnf="ksnf" :zydm="zydm" :xz="xz" @closeProgressStatisticsDialog="closeProgressStatisticsDialog"></progressStatistics>
            </div>
        </el-dialog>

        <el-dialog title="继承专业课" :visible.sync="inheritCourseDialog" @closed="closeInheritCourseDialog" width="540px" top="20vh" append-to-body>
            <el-form :model="inheritForm" ref="inheritForm" label-width="130px" label-position="left" width="100%">
                <el-row>
                    <el-form-item label="被继承学年" prop="year">
                        <el-select v-model="inheritForm.year" placeholder="学年" style="width: 100%;">
                            <el-option v-for="(item, index) in jcyear" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="inheritCourseSubmit" type="primary" style="margin-left: 10px;">
                    <i class="el-icon-document">&nbsp;确定</i></el-button>
                <el-button @click="closeInheritCourseDialog">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {confirmMsg, showNotify} from "utils/message";
import {globalConfig} from "static/config";

import occupationScope from "./occupationScope";
// import course from "./course";
import CAP from "./CourseAndProgress";
import editCAP from "./editCourseAndProgress";
import talent from "./talent";
import teachingArrangement from "./teachingArrangement";
// import teachingProgress from "./teachingProgress";
import teachingWeeks from "./teachingWeeks";
import teachingForm from "./teachingForm";
import comment from "./comment.vue";
import graduateRequire from "./graduateRequire.vue";
import coursePreConfig from "./coursePreConfig.vue";
import courseImport from "./courseImport.vue";
import audit from 'views/audit/audit.vue';
import auditList from 'views/audit/auditList.vue';
import progressStatistics from "./progressStatistics.vue";

export default {
    components: {
        talent,
        occupationScope,
        CAP,
        editCAP,
        teachingArrangement,
        teachingWeeks,
        teachingForm,
        graduateRequire,
        comment,
        coursePreConfig,
        courseImport,
        audit,
        auditList,
        progressStatistics,
    },
    data() {
        return {
            exportDialogVisible: false,
            downloading: false,
            yearStr: "",
            dept: [],
            major: [],
            comboOption: {
                dept: [],
                major: []
            },
            exportForm: {
                year: "",
                dept: "",
                major: "",
                calJjkc: null,
            },
            editDisableState: false,
            innerDialog: {
                height: "780px",
            },
            isShow: false,
            mainTableHeight: 500,
            queryForm: {
                res: 0,
                limit: 10,
                jpXn: null,
                jpZydm: null,
                jpMsdm: null,
                jpShzt: null,
                itemCode: null,
                year: null,
                majorName: null,
            },
            currentPage: 1,
            total: null,
            year: [], //起效学年下拉框
            teachMode: [], //教学模式下拉框
            status: [], //审核状态下拉框
            createClassInfo: [],//班级下拉框
            classInfo: [],//班级下拉框
            tableData: [],
            tableLoading: true,
            schemeDialogTitle: null,
            schemeDialogVisivle: false,
            formSubmiting: false,
            createBh: '',//人才培养方案编号
            createYear: '',//学年
            createZydm: '',//专业代码
            createGlbjbh: '',//指定班级编号
            timer: null,
            auditFlowInfo: null,

            //新建人培相关变量 start
            createForm: {
                workYear: null,
                majorCode: '',
                learnYear: '',
                glbjbh: '',
            },
            createFormRules: {
                workYear: [{
                    required: true,
                    trigger: ['blur', 'change'],
                    message: "请选择起效学年",
                },],
                majorCode: [{
                    required: true,
                    trigger: ['blur', 'change'],
                    message: "请选择专业",
                },],
            },
            createDialogVisivle: false,
            majorComboOption: null,
            //新建人培相关变量 end
            deletedForm: {
                kch: null,
            },
            selectRowData: null,
            courseComboInfo: [],
            type: null,
            isEdit: null,
            filelist: [],
            etype: "-1",
            sduplicateDialogVisible: false,
            mduplicateDialogVisible: false,
            sduplicateForm: {
                sorigin: null,
                starget: null,
                user: localStorage.getItem("user"),
            },
            mduplicateForm: {
                morigin: null,
                mtarget: null,
                user: localStorage.getItem("user"),
                majors: [],
            },
            majors: [],
            sorigins: [],
            sduplicateRules: {
                sorigin: [{
                    trigger: "change",
                    required: true,
                    message: "请选择模板方案",
                },],
                starget: [{
                    trigger: "change",
                    required: true,
                    message: "请选择目标学年",
                },],
            },
            mduplicateRules: {
                morigin: [{
                    trigger: "change",
                    required: true,
                    message: "请选择起始学年",
                },],
                mtarget: [{
                    trigger: "change",
                    required: true,
                    message: "请选择目标学年",
                },],
            },
            tmida: null,
            tmidb: null,
            importButtonVisible: false,
            saveButtonVisible: false,
            submitButtonVisible: false,
            auditButtonVisible: false,
            auditDialogVisible: false,
            auditListDialogVisible: false,
            auditParam: null,
            syncDataVisible: false,
            syncDataMask: null,
            coursePreConfigDialogVisible: false,
            courseImportDialogTitle: null,
            courseImportDialogVisible: false,
            //导入教学进程表
            importDialogVisible: false,
            fileImporting: false,
            importButton: '上传文件',
            topHeight: 0 + 'px',
            errorDialogVisible: false,
            errorMessage: '',
            loadingMask: null,
            weekall: null,
            ksnf: '',
            zydm: '',
            xz: '',
            id: '',
            ggkAuth: null,

            progressStatisticsDialogVisible: false,
            sfzt: [],
            exportCAPVisible: false,
            currentPage_editScheme: 1,
            limit_editScheme: 10,
            total_editScheme: null,
            editSchemeData: [],
            editSchemeTableHeight: 550,
            selectRowData_editScheme: null,
            kcsxholder: '请先选择课程',
            kcsxDisabled: true,
            kclxInfo: [],
            kcsxInfo: [],
            kcsx: [],
            courseInfo: [],
            assessFormInfo: [],
            jpZymc: null,
            jxjcId: null,
            jxjcTitle: null,
            jxjcShow: null,
            jxjcDialogVisible: false,
            jxjcbgDialogVisible: false,
            jxjcbgListDialogVisible: false,
            auditParam_jxjc: 'JXJCBG',
            auditState: null,
            oldJxjcData: [],
            jxjcCompareDialogVisible: false,
            editSchemeDialogVisivle: false,//审核后变革教学进程表
            showSchemeDialogVisivle: false,//显示原教学进程表
            jxjcHeight: '200px',

            queryJxjcForm: {
                res: 0,
                limit: 10,
                jjBh: null,
                jjXn: null,
                jjZydm: null,
                jjShzt: null,
                itemCode: 'JXJCBG',
            },
            jxjcForm: {
                jjXn: null,
                jjZydm: null,
                jjZymc: null,
                jjXz: null,
                res: 1,
                limit: 10,
                jjBh: null,
                jjBglx: null,
                jjJxjcbh: '',
                jjJxjckcdm: '',
                jjJxjckcmc: '',
                jjPyfabh: null,
                jjKcdm: null,
                jjKcmc: null,
                jjKclx: null,
                jjKclxmc: null,
                jjKcsx: null,
                jjKcsxmc: null,
                jjZxs: 0,
                jjXf: 0,
                isMajorcore: null,
                isCertificate: null,
                jjKhfs: null,
                jjKhfsmc: null,
                jjLljx: 0,
                jjSysx: 0,
                jjXq1: 0,
                jjXq2: 0,
                jjXq3: 0,
                jjXq4: 0,
                jjXq5: 0,
                jjXq6: 0,
                jjXq7: 0,
                jjXq8: 0,
                jjXq9: 0,
                jjXq10: 0,
                jjZx1: 0,
                jjZs2: 0,
                jjZs3: 0,
                jjZs4: 0,
                jjZs5: 0,
                jjZs6: 0,
                jjZs7: 0,
                jjZs8: 0,
                jjZs9: 0,
                jjZs10: 0,
                jjTjzt: null,
                jjShzt: null,
                jjZt: null,
                jjBz: null,
                saveType: null,
                type: null,
            },
            editJxjcForm: [{
                jjXn: null,
                jjZydm: null,
                jjZymc: null,
                jjXz: null,
                res: 1,
                limit: 10,
                jjBh: null,
                jjBglx: null,
                jjJxjcbh: '',
                jjJxjckcdm: '',
                jjJxjckcmc: '',
                jjPyfabh: null,
                jjKcdm: null,
                jjKcmc: null,
                jjKclx: null,
                jjKclxmc: null,
                jjKcsx: null,
                jjKcsxmc: null,
                isMajorcore: null,
                isCertificate: null,
                jjZxs: 0,
                jjXf: 0,
                jjKhfs: null,
                jjKhfsmc: null,
                jjLljx: 0,
                jjSysx: 0,
                jjXq1: 0,
                jjXq2: 0,
                jjXq3: 0,
                jjXq4: 0,
                jjXq5: 0,
                jjXq6: 0,
                jjXq7: 0,
                jjXq8: 0,
                jjXq9: 0,
                jjXq10: 0,
                jjZx1: 0,
                jjZs2: 0,
                jjZs3: 0,
                jjZs4: 0,
                jjZs5: 0,
                jjZs6: 0,
                jjZs7: 0,
                jjZs8: 0,
                jjZs9: 0,
                jjZs10: 0,
                jjTjzt: null,
                jjShzt: null,
                jjZt: null,
                jjBz: null,
                saveType: null,
                type: null,
            }],
            oldJxjcForm: [{
                jjXn: null,
                jjZydm: null,
                jjZymc: null,
                jjXz: null,
                res: 1,
                limit: 10,
                jjBh: null,
                jjBglx: null,
                jjJxjcbh: '',
                jjJxjckcdm: '',
                jjJxjckcmc: '',
                jjPyfabh: null,
                jjKcdm: null,
                jjKcmc: null,
                jjKclx: null,
                jjKclxmc: null,
                jjKcsx: null,
                jjKcsxmc: null,
                isMajorcore: null,
                isCertificate: null,
                jjZxs: 0,
                jjXf: 0,
                jjKhfs: null,
                jjKhfsmc: null,
                jjLljx: 0,
                jjSysx: 0,
                jjXq1: 0,
                jjXq2: 0,
                jjXq3: 0,
                jjXq4: 0,
                jjXq5: 0,
                jjXq6: 0,
                jjXq7: 0,
                jjXq8: 0,
                jjXq9: 0,
                jjXq10: 0,
                jjZx1: 0,
                jjZs2: 0,
                jjZs3: 0,
                jjZs4: 0,
                jjZs5: 0,
                jjZs6: 0,
                jjZs7: 0,
                jjZs8: 0,
                jjZs9: 0,
                jjZs10: 0,
                jjTjzt: null,
                jjShzt: null,
                jjZt: null,
                jjBz: null,
                saveType: null,
                type: null,
            }],
            newJxjcForm: [{
                jjXn: null,
                jjZydm: null,
                jjZymc: null,
                jjXz: null,
                res: 1,
                limit: 10,
                jjBh: null,
                jjBglx: null,
                jjJxjcbh: '',
                jjJxjckcdm: '',
                jjJxjckcmc: '',
                jjPyfabh: null,
                jjKcdm: null,
                jjKcmc: null,
                jjKclx: null,
                jjKclxmc: null,
                jjKcsx: null,
                jjKcsxmc: null,
                isMajorcore: null,
                isCertificate: null,
                jjZxs: 0,
                jjXf: 0,
                jjKhfs: null,
                jjKhfsmc: null,
                jjLljx: 0,
                jjSysx: 0,
                jjXq1: 0,
                jjXq2: 0,
                jjXq3: 0,
                jjXq4: 0,
                jjXq5: 0,
                jjXq6: 0,
                jjXq7: 0,
                jjXq8: 0,
                jjXq9: 0,
                jjXq10: 0,
                jjZx1: 0,
                jjZs2: 0,
                jjZs3: 0,
                jjZs4: 0,
                jjZs5: 0,
                jjZs6: 0,
                jjZs7: 0,
                jjZs8: 0,
                jjZs9: 0,
                jjZs10: 0,
                jjTjzt: null,
                jjShzt: null,
                jjZt: null,
                jjBz: null,
                saveType: null,
                type: null,
            }],
            jxjcRule: {//表单验证
                jjKclx: [{required: true, message: "请选择课程类别", trigger: ["blur", "change"]}],
                jjKcsx: [{required: true, message: "请选择课程性质", trigger: ["blur", "change"]}],
                jjKcdm: [{required: true, message: "请选择课程", trigger: ["blur", "change"]}],
            },

            inheritCourseDialog: false,
            inheritForm: {
                curyear: null,
                year: null,
                courseDept: null,
                course: null,
            },
            jcyear: [],//被继承学年
        };
    },
    mounted() {
        this.syncDataVisible = globalConfig.syncDataVisible;
        this.queryGGKAuth();
        this.queryAuditParam();
        this.initParam();

        this.topHeight = (window.innerHeight - 274 - 200) / 2 + 'px';
        this.$nextTick().then(() => {
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
            // 监听窗口大小变化
            let self = this;
            window.onresize = function () {
                self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
            };
            this.innerDialog.height = window.innerHeight / 1.21 + "px";

            $(".el-dialog.is-fullscreen").css("overflow-y", "hidden");
        });
    },
    methods: {
        queryUserInfo() {
            this.$api.system.basic.userInfo({}).then((res) => {
                const userInfo = res.data.data;

                if (userInfo) {
                    this.userName = userInfo.name;
                    let roleInfo = userInfo.roles;

                    for (let roleCode in roleInfo) {
                        // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                        this.userRole.push(roleCode);
                    }
                } else {
                    // this.$router.push('/login');
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        queryGGKAuth() {
            this.$api.teachingManage.teachingScheme.queryGGKAuth({}).then((res) => {
                this.ggkAuth = res.data.data.auth;
            }).catch((err) => {
                console.log(err);
            });
        },
        hasPermisson(authArray) {
            // let permissonState = false;

            // for(let i=0; i<this.authArray.length; i++){
            //     for(let j=0; j<this.authArray.length; j++){
            //         if(this.userRole[i] === this.authArray[j]){
            //             permissonState = true;
            //             break;
            //         }
            //     }
            // }

            // return permissonState;

            //管理员审核后可以变更人才培养方案
            return this.userRole.indexOf(globalConfig.auth.admin) > -1;
        },
        changeDept() {
            this.comboOption.major = []
            this.major = []

            if (this.dept.length > 0) {
                const params = {
                    "deptCode": this.dept.join(",")
                }
                this.$api.common.comboOption.major({
                    data: params
                }).then((res) => {
                    this.comboOption.major = res.data.data.comboData;
                }).catch((error) => {
                    console.log(error);
                });
            }
        },
        changeMajor(val) {
            this.createZydm = val;
        },
        exportDialogVisibleClose() {
            this.yearStr = '';
            this.dept = [];
            this.major = [];
            this.comboOption.major = []
        },
        //文件导出
        fileExport() {
            this.exportDialogVisible = false;
            // this.downloading = true;
            this.showLoadingMask("导出中，请稍候...");

            this.exportForm.year = this.yearStr;
            this.exportForm.dept = this.dept.join(",");
            this.exportForm.major = this.major.join(",");
            this.$api.teachingManage.teachingScheme.export({
                responseType: "blob",
                data: this.exportForm
            }).then((res) => {
                const _this = this;
                const resultData = res.data;

                const fileReader = new FileReader();
                fileReader.onload = function () {
                    if (resultData.type == 'application/json') {
                        const jsonData = JSON.parse(fileReader
                            .result); // 说明是普通对象数据，后台转换失败
                        showNotify('错误', jsonData.msg, 'error', 3000);
                    } else {
                        const fileName = decodeURI(res.headers['content-disposition']
                            .split('fileName=')[1]);
                        _this.downloadFileByBlob(resultData, fileName);
                    }
                };
                fileReader.readAsText(resultData);

                this.downloading = false
            }).catch((err) => {
                console.log(err);
                this.downloading = false
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        /**显示loading**/
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        downloadFileByBlob(data, fileName) {
            let blob = new Blob([data], {
                type: "application/ms-excel;charset=utf-8"
            });

            //浏览器兼容，Google和火狐支持a标签的download，IE不支持
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                let url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            }
        },
        submitStateFormatter(row) {
            return row.jpTjzt === '1' ? '已提交' : '未提交';
        },
        submitStateFormatter_editscheme(row) {
            return row.jjTjzt === '1' ? '已提交' : '未提交';
        },
        auditStateFormatter(row) {
            let str = '';

            if (row.jpShzt === '1') {
                str = '通过';
            } else if (row.jpShzt === '2') {
                str = '驳回';
            } else {
                if (row.jpTjzt === '1') {
                    if (row.auditLevel === '1') {
                        str = '待审核';
                    } else {
                        str = '审核中';
                    }
                } else {
                    str = '未提交';
                }
            }

            return str;
        },
        //审状态列样式处理
        handleCellStyle({row, column, rowIndex, columnIndex}) {
            let cellStyle;

            if (columnIndex === 7) {
                switch (row.jpShzt) {
                    case '1':
                        cellStyle = 'color: #00FF40 !important;';
                        break;
                    case '2':
                        cellStyle = 'color: #FE2E2E !important;';
                        break;
                    default:
                        cellStyle = '';
                }

                return cellStyle;
            }
        },
        loadParams(id) {
            this.id = id;
            this.ksnf = this.$refs.teachingForm.createdForm.jpXn;
            this.zydm = this.$refs.teachingForm.createdForm.jpZydm;
            this.xz = this.$refs.teachingForm.createdForm.institution;
            let mode = this.$refs.teachingForm.createdForm.jpMsdm;
            if (this.zydm == "") return;
            this.$refs.CAP.loadComboOption(mode);
            let param = {
                majorId: this.zydm,
                schemeId: id,
            };
            this.$api.teachingManage.teachingScheme.queryCourses({
                data: param,
            }).then((res) => {
                this.courseComboInfo = res.data.data;
            }).catch((err) => {
                console.log(err);
            });
        },
        initParam() {
            this.$api.teachingManage.teachingScheme.initOption({
                data: null,
            }).then((response) => {
                this.year = response.data.data.year;
                this.teachMode = response.data.data.teachMode;
                this.status = response.data.data.status;
                this.sorigins = response.data.data.sorigins;
                this.majors = response.data.data.majors;

                this.comboOption.dept = response.data.data.dept;
                this.majorComboOption = response.data.data.majorComboData;

                this.createForm.workYear = this.year[0].comboValue;

                this.sfzt = response.data.data.sfzt;
                this.exportForm.calJjkc = '0';
                this.kclxInfo = response.data.data.courseType;//课程类型
                this.kcsxInfo = response.data.data.courseProperties;//课程属性
                this.kcsx = response.data.data.courseProperties;//课程属性
                this.assessFormInfo = response.data.data.assessForm;//考核方式

                this.classOption();
            }).catch((error) => {
                console.log(error);
            });
        },
        yearChange(val) {
            this.createForm.workYear = val;
            this.classOption();
        },
        majorChange(val) {
            this.createForm.majorCode = val;
            if (val != '') {
                let obj = {};
                obj = this.majorComboOption.find((item) => {
                    return item.comboValue === val;//筛选出匹配数据
                });
                this.createForm.learnYear = obj.otherInfo;
            }
            this.classOption();
        },
        classOption() {
            this.$api.teachingManage.teachingScheme.classOption({
                data: this.createForm,
            }).then((response) => {
                this.createClassInfo = response.data.data.class;
            }).catch((error) => {
                console.log(error);
            });
        },
        classOption2() {
            const params = {
                "workYear": this.createYear,
                "majorCode": this.createZydm,
            }
            this.$api.teachingManage.teachingScheme.classOption({
                data: params,
            }).then((response) => {
                this.classInfo = response.data.data.class;
            }).catch((error) => {
                console.log(error);
            });
        },
        queryList() {
            this.tableLoading = true;
            this.queryForm.res = (this.currentPage - 1) * this.queryForm.limit;
            this.$api.teachingManage.teachingScheme.list({
                data: this.queryForm,
            }).then((res) => {
                this.total = res.data.data.total;
                this.tableData = res.data.data.list;
                this.tableLoading = false;
            }).catch((err) => {
                this.tableLoading = false;
                console.log(err);
            });
        },
        handleFilter() {
            this.currentPage = 1;
            this.queryList();
        },
        handleReset() {
            this.queryForm.limit = 10;
            this.currentPage = 1;
            this.queryForm.year = null;
            this.queryForm.majorName = null;
            this.tableLoading = false;
            this.queryForm.jpXn = null;
            this.queryForm.jpZydm = null;
            this.queryForm.jpShzt = null;
            this.queryList();
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.queryList();
        },
        handleCurrentChange(val) {
            //this.selectRowData = val;
        },
        handleSizeChange(val) {
            this.queryForm.limit = val;
            this.queryForm.currentPage = 1;
            this.queryList();
        },
        closeSchemeDialog() {
            this.schemeDialogVisivle = false;

            //停止自动保存
            this.disableAutoSave();

            //数据重置
            this.$refs.teachingForm.createdForm = {
                jpBh: "",
                jpXn: "",
                jpMsdm: "",
                jpZydm: "",
                jpZybm: "",
                jpRxyq: "",
                jpPymb: "",
                jpCjr: "",
                userName: "",
                jpYjlj: "",
                jpYjwjm: "",
                institution: "3",
                jpTjzt: "",
            };
            let occupation = this.$refs.occupation;
            occupation.domain = [];
            occupation.position = [];
            occupation.certificate = [];
            occupation.domainMult = [];
            occupation.positioniMult = [];
            occupation.certificateMult = [];

            let talent = this.$refs.talent;
            talent.quality = [];
            talent.qualityMult = [];
            talent.ability = [];
            talent.abilityMult = [];

            let CAP = this.$refs.CAP;
            CAP.CAPS = [];
            CAP.kinds = [];
            CAP.courseMult = [];
            CAP.optionCourses = [];
            this.courseComboInfo = [];

            this.$refs.arrangement.arrangeMent = [{
                name: "一",
                jjXqxh: 1,
                jjRxjy: 0,
                jjShsj: 0,
                jjKtjx: 0,
                jjSxsy: 0,
                jjSx: 0,
                jjKs: 0,
                jjJd: 0,
                jjJq: 0,
                jjZj: 0,
            },
                {
                    name: "二",
                    jjXqxh: 2,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "三",
                    jjXqxh: 3,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "四",
                    jjXqxh: 4,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "五",
                    jjXqxh: 5,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "六",
                    jjXqxh: 6,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "七",
                    jjXqxh: 7,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "八",
                    jjXqxh: 8,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "九",
                    jjXqxh: 9,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
                {
                    name: "十",
                    jjXqxh: 10,
                    jjRxjy: 0,
                    jjShsj: 0,
                    jjKtjx: 0,
                    jjSxsy: 0,
                    jjSx: 0,
                    jjKs: 0,
                    jjJd: 0,
                    jjJq: 0,
                    jjZj: 0,
                },
            ];

            this.$refs.teachingWeeks.teachingWeeks = [{
                t1: {
                    jxJxzs: 18,
                    jxXqxh: 1,
                },
                t2: {
                    jxJxzs: 18,
                    jxXqxh: 2,
                },
                t3: {
                    jxJxzs: 18,
                    jxXqxh: 3,
                },
                t4: {
                    jxJxzs: 18,
                    jxXqxh: 4,
                },
                t5: {
                    jxJxzs: 18,
                    jxXqxh: 5,
                },
                t6: {
                    jxJxzs: 18,
                    jxXqxh: 6,
                },
                t7: {
                    jxJxzs: 18,
                    jxXqxh: 7,
                },
                t8: {
                    jxJxzs: 18,
                    jxXqxh: 8,
                },
                t9: {
                    jxJxzs: 18,
                    jxXqxh: 9,
                },
                t10: {
                    jxJxzs: 18,
                    jxXqxh: 10,
                },
            },];
            this.$refs.teachingWeeks.handleChange();

            this.$refs.graduateRequire.createdForm = {
                id: null,
                ggjcbxkcCredit: 0,
                ggjcxdxxkcCredit: 0,
                ggjcryxxkccCredit: 0,
                zyjckcCredit: 0,
                zyhxkcCredit: 0,
                zytzxxkcCredit: 0,
                sjjxhjCredit: 0,
                totalCredit: 0,
                qtyq: '',
            };

            this.$refs.comment.coms = "";

            this.editDisableState = false;

            this.$refs.comment.fileList = [];
        },
        closeEditSchemeDialog() {
            this.editSchemeDialogVisivle = false;
        },
        closeShowSchemeDialog() {
            this.showSchemeDialogVisivle = false;
        },
        showDialog(type) {
            if (type == "sduplicate") {
                this.sduplicateDialogVisible = true;
                this.initParam();
                if (this.$refs.teachingForm.createdForm.jpXn != '') {
                    this.sduplicateForm.starget = this.$refs.teachingForm.createdForm.jpXn;
                }
            }
            if (type == "mduplicate") {
                this.mduplicateDialogVisible = true;
                this.initParam();
            }
        },
        addRec() {
            // this.importButtonVisible = true;
            // this.saveButtonVisible = true;
            // this.submitButtonVisible = true;
            // this.auditButtonVisible = false;

            // this.isEdit = false;
            // this.etype = "-1";
            // this.schemeDialogTitle = "新建";
            // this.schemeDialogVisivle = true;
            // this.$nextTick(() => {
            //     this.$refs.teachingForm.createdForm.jpTjzt = "-1";
            //     this.$refs.teachingForm.createdForm.jpFbrq = this.getCurrentFormatDate();
            //     this.$refs.teachingForm.createdForm.userName = localStorage.getItem(
            //         "name"
            //     );
            //     this.$refs.teachingForm.createdForm.jpCjr = localStorage.getItem(
            //         "user"
            //     );
            // });

            // this.$nextTick(() => {
            //     this.$refs.elScrollbar.wrap.scrollTop = 0;
            // });

            // this.enableAutoSave();

            //20230307修改操作流程
            this.createDialogVisivle = true;
        },
        modRec(rowData) {
            this.importButtonVisible = true;
            this.saveButtonVisible = true;
            this.submitButtonVisible = true;
            this.auditButtonVisible = false;
            this.schemeDialogTitle = "编辑";

            this.showDetailDialog(rowData);

            this.enableAutoSave();
        },
        changeRec() {
            this.saveButtonVisible = false;
            this.submitButtonVisible = false;
            this.auditButtonVisible = false;
            this.schemeDialogTitle = "变更教学进程表";

            this.showEditDetailDialog(this.selectRowData);
        },
        showRec(rowData) {
            this.importButtonVisible = false;
            this.saveButtonVisible = false;
            this.submitButtonVisible = false;
            this.auditButtonVisible = false;
            this.schemeDialogTitle = "详情";

            this.showDetailDialog(rowData);
        },
        auditRec(rowData) {
            this.importButtonVisible = false;
            this.saveButtonVisible = false;
            this.submitButtonVisible = false;
            this.auditButtonVisible = true;
            this.schemeDialogTitle = "审核";

            this.showDetailDialog(rowData);
        },
        showDetailDialog(rowData) {
            this.ksnf = rowData.jpXn;
            this.zydm = rowData.jpZydm;
            this.xz = rowData.institution;
            this.selectRowData = rowData;
            this.createBh = this.selectRowData.jpBh;
            this.queryJxjcForm.jjBh = this.selectRowData.jpBh;
            this.createYear = this.selectRowData.jpXn;
            this.createZydm = this.selectRowData.jpZydm;
            this.createGlbjbh = this.selectRowData.jpGlbjbh;
            this.auditState = rowData.jpShzt;
            this.classOption2();
            this.timer = new Date().getTime();

            if (this.selectRowData == null) {
                this.$alert("请先选择一条记录", "提示", {
                    confirmButtonText: "确定",
                });

                return;
            }

            this.lock();
            let id = this.selectRowData.jpBh;
            let mode = id[id.length - 1];
            this.isEdit = true;
            this.schemeDialogVisivle = true;

            //预先查询课程
            let param = {
                schemeId: id,
            };
            this.$api.teachingManage.teachingScheme.queryAllCourses({
                data: param,
            }).then((res) => {
                this.$refs.CAP.optionCourses = res.data;
            }).catch((err) => {
                console.log(err);
            });

            this.$api.teachingManage.teachingScheme.queryAllPositions().then((res) => {
                this.$refs.occupation.optionPosition = res.data;
            }).catch((err) => {
                console.log(err);
            });

            this.$nextTick(() => {
                this.loadInfo(id);
                this.$refs.CAP.loadComboOption(mode);
                this.$refs.elScrollbar.wrap.scrollTop = 0;
            });
        },
        delRec(rowData) {
            this.selectRowData = rowData;

            if (this.selectRowData == null) {
                this.$alert("请先选择一条记录", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }

            confirmMsg('此操作将永久删除选择的人才培养方案信息，是否继续？').then(() => {
                let param = {
                    schemeId: this.selectRowData.jpBh,
                };
                this.$api.teachingManage.teachingScheme.deleteById({
                    data: param,
                }).then((response) => {
                    showNotify('成功', '删除成功', 'success', 1500);
                    this.queryList();
                    this.initParam();
                }).catch((error) => {
                    this.formSubmiting = false;
                    showNotify('错误', error, 'error', 3000);
                });

                this.selectRowData = null;
            });
        },
        queryForYear() {
            let params = {
                queryForYear: "1"
            };
            this.$api.teachingManage.teachingScheme.queryForYear({
                data: params,
            }).then((res) => {
            }).catch((err) => {
            });
        },
        loadInfo(id) {
            $('#loadingMask').show();

            this.id = id;
            this.$refs.comment.param.schemeId = this.id;
            let param = {
                schemeId: id,
            };

            this.$api.teachingManage.teachingScheme.loadInfo({
                data: param,
            }).then((res) => {
                let data = res.data;
                this.$refs.teachingForm.createdForm = data.scheme;
                if (this.$refs.teachingForm.createdForm.jpGlbjbh == '') {
                    this.$refs.teachingForm.createdForm.jpGlbjbh = "";
                } else {
                    this.$refs.teachingForm.createdForm.jpGlbjbh = this.$refs.teachingForm.createdForm.jpGlbjbh.split(",");
                }

                this.$refs.occupation.domain = data.domain;
                this.$refs.occupation.position = data.position;
                this.$refs.occupation.certificate = data.certificate;
                this.$refs.talent.quality = data.quality;
                this.$refs.talent.ability = data.ability;
                this.$refs.CAP.CAPS = data.caps;
                this.$refs.CAP.teachingSchemeCode = this.id;
                this.$refs.graduateRequire.createdForm = data.graduateRequire;
                this.$refs.comment.coms = data.scheme.jpBz;
                if (data.fileList.length != 0)
                    data.fileList[0].url = Vue.prototype.HOST_PROXY_ADMIN + data.fileList[0].url;
                this.$refs.comment.fileList = data.fileList;
                this.loadParams(this.id);
                if (data.weeks.length != 0)
                    this.data2Weeks(data.weeks);
                if (data.arrangement.length != 0)
                    this.arrange2N(data.arrangement);

                this.etype = data.scheme.jpTjzt;
                this.unlock();
                if (data.scheme.jpTjzt == "1") this.editDisableState = true;

                this.$nextTick(() => {
                    // 改变合计行样式
                    $(".el-table__footer-wrapper").css(
                        "font-weight",
                        "bold"
                    );
                    $(".el-table__footer-wrapper tr").css(
                        "font-weight",
                        "bold"
                    );

                    $('#loadingMask').hide();

                    //滚动到教学进程表
                    this.$refs.elScrollbar.wrap.scrollTop = 1100;
                });
            }).catch((err) => {
                this.unlock();
                console.log(err);
            });
        },
        arrange2N(data) {
            data[0].name = "一";
            data[1].name = "二";
            data[2].name = "三";
            data[3].name = "四";
            data[4].name = "五";
            data[5].name = "六";
            data[6].name = "七";
            data[7].name = "八";
            data[8].name = "九";
            data[9].name = "十";
            this.$refs.arrangement.arrangeMent = data;
        },
        data2Weeks(data) {
            let ans = [];
            let week = {
                t1: data[0],
                t2: data[1],
                t3: data[2],
                t4: data[3],
                t5: data[4],
                t6: data[5],
                t7: data[6],
                t8: data[7],
                t9: data[8],
                t10: data[9],
            };
            ans.push(week);
            this.$refs.teachingWeeks.teachingWeeks = ans;
            this.$refs.teachingWeeks.handleChange();
        },
        transweeks(weeks) {
            //使得progress里表头数据动态绑定
            this.$refs.CAP.weeks = weeks;
        },
        changeArrange(value) {
            //使得arrangement里的课堂教学动态绑定
            this.$refs.arrangement.arrangeMent[0].jjKtjx = value.t1.jxJxzs;
            this.$refs.arrangement.arrangeMent[1].jjKtjx = value.t2.jxJxzs;
            this.$refs.arrangement.arrangeMent[2].jjKtjx = value.t3.jxJxzs;
            this.$refs.arrangement.arrangeMent[3].jjKtjx = value.t4.jxJxzs;
            this.$refs.arrangement.arrangeMent[4].jjKtjx = value.t5.jxJxzs;
            this.$refs.arrangement.arrangeMent[5].jjKtjx = value.t6.jxJxzs;
            this.$refs.arrangement.arrangeMent[6].jjKtjx = value.t7.jxJxzs;
            this.$refs.arrangement.arrangeMent[7].jjKtjx = value.t8.jxJxzs;
            this.$refs.arrangement.arrangeMent[8].jjKtjx = value.t9.jxJxzs;
            this.$refs.arrangement.arrangeMent[9].jjKtjx = value.t10.jxJxzs;
        },
        submitWapper() {
            confirmMsg('提交后将无法再次修改当前人才培养方案，是否继续？').then(() => {
                this.saveScheme("submit");
            });
        },
        saveScheme(type) {
            this.lock();
            let x = this.$refs.teachingForm.createdForm;
            let errorMsg = "";
            if (x.jpXn == "") {
                errorMsg = "请选择起效学年";
            }
                // else if (x.jpMsdm == "") {
                //     errorMsg = "请选择模式";
            // }
            else if (x.jpZydm == "") {
                errorMsg = "请选择专业名称";
            }

            if (errorMsg.length > 0) {
                showNotify('错误', errorMsg, 'error', 3000);
                errorMsg = "";
                this.unlock();
                return;
            }

            //设置审核状态
            if (type == "save") {
                x.jpTjzt = "0";
            }
            if (type == "submit") {
                x.jpTjzt = "1";
            }
            if (type == "audit") {
            }

            let occupation = this.$refs.occupation.domain.concat(
                this.$refs.occupation.position,
                this.$refs.occupation.certificate
            );
            if (this.$refs.comment.fileList.length != 0) {
                this.$refs.teachingForm.createdForm.jpYjlj = this.$refs.comment.fileList[0].originPath;
                this.$refs.teachingForm.createdForm.jpYjwjm = this.$refs.comment.fileList[0].name;
            }

            let params = {
                scheme: this.$refs.teachingForm.createdForm,
                weeks: this.$refs.teachingWeeks.teachingWeeks,
                quality: this.$refs.talent.quality,
                ability: this.$refs.talent.ability,
                caps: this.$refs.CAP.CAPS,
                arrangement: this.$refs.arrangement.arrangeMent,
                occupation: occupation,
                graduateRequire: this.$refs.graduateRequire.createdForm,
                coms: this.$refs.comment.coms,
                jpBh: this.createBh,
                jpGlbjbh: this.createGlbjbh,
            };
            console.log(this.$refs.CAP.CAPS);
            this.$api.teachingManage.teachingScheme.saveScheme({
                data: params,
            }).then((res) => {
                showNotify('成功', '保存成功', 'success', 1500);
                this.queryList();
                this.afterSave(type);
                this.unlock();
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
                this.unlock();
            });
        },
        afterSave(type) {
            this.isEdit = true;
            this.schemeDialogTitle = "编辑";
            if (type == "save") {
                this.etype = "0";
                this.$refs.teachingForm.createdForm.jpTjzt = "0";
                this.schemeId = this.$refs.teachingForm.createdForm.jpBh;
            }
            if (type == "submit") {
                this.etype = "1";
                this.$refs.teachingForm.createdForm.jpTjzt = "1";
                this.editDisableState = true;
                this.closeSchemeDialog();
            }
        },
        getId(length) {
            return Number(
                Math.random().toString().substr(3, length) + Date.now()
            ).toString(36);
        },
        openWindow(query) {
            if (this.$refs.teachingForm.createdForm.jpBh == "") {
                showNotify('错误', "请先选择基本信息", 'error', 3000);
                return;
            }

            query = globalConfig.FONT_PROXY_PATH + "/#/courseStandard/" + this.$refs.teachingForm.createdForm.jpBh +
                query;
            window.open(query);
        },
        changeEditRow(refName) {
            //职业领域
            if (refName != "domain") this.$refs.occupation.$refs.domain.setCurrentRow();
            //职业岗位
            if (refName != "position") this.$refs.occupation.$refs.position.setCurrentRow();
            //职业证书
            if (refName != "certificate") this.$refs.occupation.$refs.certificate.setCurrentRow();
            //职业素养
            if (refName != "qualityTable") this.$refs.talent.$refs.qualityTable.setCurrentRow();
            //职业能力
            if (refName != "abilityTable") this.$refs.talent.$refs.abilityTable.setCurrentRow();
            //教学周数
            // if(refName!='teachingWeeksTable') this.$refs.teachingWeeks.$refs.teachingWeeksTable.setCurrentRow();
            //课程内容与要求
            // if(refName!='teachingWeeksTable') this.$refs.teachingWeeks.$refs.teachingWeeksTable.setCurrentRow();
            //教学活动时间安排表
            if (refName != "arrangementTable") this.$refs.arrangement.$refs.arrangementTable.setCurrentRow();
            //教学进程表
            // if (refName != "progressTable") this.$refs.progress.$refs.progressTable.setCurrentRow();
            if (refName != "CAPTable") this.$refs.CAP.$refs.CAPTable.setCurrentRow();
        },
        enableAutoSave() {
            if (!this.isEdit) return;

            this.tmida = setTimeout(() => {
                this.tmidb = setInterval(this.intervalFun(), 60 * 1000);
            }, 3 * 60 * 1000);
        },
        disableAutoSave() {
            if (null != this.tmida) {
                clearTimeout(this.tmida);
                this.tmida = null;
            }

            if (null != this.tmidb) {
                clearInterval(this.tmidb);
                this.tmidb = null;
            }
        },
        intervalFun() {
            let x = this.$refs.teachingForm.createdForm;
            if (x.jpBh == "") return;
            let occupation = this.$refs.occupation.domain.concat(
                this.$refs.occupation.position,
                this.$refs.occupation.certificate
            );
            if (this.$refs.comment.fileList.length != 0) {
                this.$refs.teachingForm.createdForm.jpYjlj = this.$refs.comment.fileList[0].originPath;
                this.$refs.teachingForm.createdForm.jpYjwjm = this.$refs.comment.fileList[0].name;
            }
            let params = {
                scheme: this.$refs.teachingForm.createdForm,
                weeks: this.$refs.teachingWeeks.teachingWeeks,
                quality: this.$refs.talent.quality,
                ability: this.$refs.talent.ability,
                caps: this.$refs.CAP.CAPS,
                arrangement: this.$refs.arrangement.arrangeMent,
                occupation: occupation,
                coms: this.$refs.comment.coms,
            };

            this.$api.teachingManage.teachingScheme.saveScheme({
                data: params,
            }).then((res) => {
            }).catch((err) => {
            });
        },
        sduplicateDialogCancel() {
            this.sduplicateDialogVisible = false;
            this.$refs.sduplicateForm.resetFields();
        },
        mduplicateDialogCancel() {
            this.mduplicateDialogVisible = false;
            this.$refs.mduplicateForm.resetFields();
        },
        sduplicate() {
            this.$refs.sduplicateForm.validate((valid) => {
                if (valid) {
                    confirmMsg('此操作将覆盖目标人才培养方案，是否继续？').then(() => {
                        this.$api.teachingManage.teachingScheme.sduplicate({
                            data: this.sduplicateForm,
                        }).then((res) => {
                            showNotify('成功', '复制成功', 'success', 1500);

                            this.queryList();
                            this.sduplicateDialogCancel();

                            let that = this;
                            setTimeout(function () {
                                that.loadInfo(res.data);
                            }, 1000);
                        }).catch((err) => {
                            showNotify('错误', err, 'error', 3000);
                        });
                    });
                }
            });
        },
        mduplicate() {
            this.$refs.mduplicateForm.validate((valid) => {
                if (valid) {
                    confirmMsg('此操作将覆盖目标人才培养方案，是否继续？').then(() => {
                        this.$api.teachingManage.teachingScheme.mduplicate({
                            data: this.mduplicateForm,
                        }).then((res) => {
                            this.mduplicateDialogCancel();
                            this.$nextTick(() => {
                                this.queryList();
                                showNotify('成功', '复制成功', 'success', 1500);
                            });
                        }).catch((err) => {
                            showNotify('错误', err, 'error', 3000);
                        });
                    });
                }
            });
        },
        hanleMoriginChange(val) {
            this.$api.teachingManage.teachingScheme.queryMajorsInScheme({
                data: {
                    origin: val
                },
            }).then((res) => {
                this.mduplicateForm.majors = [];
                this.majors = res.data.majors;
            }).catch((err) => {
                console.log(err);
            });
        },
        singleExport() {
            let data = this.selectRowData;
            this.$api.teachingManage.teachingScheme.singleExport({
                data: {
                    schemeId: this.id
                },
                responseType: "blob",
            }).then((res) => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = data.jpXn + data.fullName + "培养方案" + ".docx";
                if ("download" in document.createElement("a")) {
                    // 非IE下载
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName);
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        // 改变进程的合并列
        changeindexs() {
            console.log("change the inedx");
            this.$refs.progress.start = 0;
        },
        lock() {
            this.editDisableState = true;
        },
        unlock() {
            this.editDisableState = false;
        },
        syncData() {
            this.$api.teachingManage.teachingScheme.syncData({}).then(response => {
                showNotify('成功', '同步成功', 'success', 1500);
            }).catch(error => {
                showNotify('错误', "同步失败", 'error', 3000);
            });
        },
        //查询审核调用参数
        queryAuditParam() {
            const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/") + 1);

            this.$api.common.audit.auditParam({
                data: {
                    pageName: pageName
                },
            }).then((res) => {
                this.auditParam = res.data.data.auditParam;
                this.queryForm.itemCode = this.auditParam;
                this.queryList();
            }).catch((err) => {
                console.log(err);
            });
        },
        showAuditDialog() {
            this.auditDialogVisible = true;
        },
        //审核后回调函数
        auditCallback(auditInfo) {
            this.auditDialogVisible = false;
            this.closeSchemeDialog();
            this.updateAuditState(auditInfo);
        },
        //完成审核后更新审核状态
        updateAuditState(auditInfo) {
            this.$api.teachingManage.teachingScheme.updateAuditState({
                data: auditInfo,
            }).then((response) => {
                let state = response.data.data.state;
                if (state == 'Success') {
                    this.queryList();
                } else {
                    showNotify('错误', '审核状态更新失败', 'error', 3000);
                }
            }).catch((error) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        //显示审核详情列表
        showAuditList(row) {
            this.$api.teachingManage.teachingScheme.queryAuditFlow({
                data: {
                    itemCode: this.queryForm.itemCode,
                    relatedCode: row.jpBh,
                    auditState: row.jpShzt,
                    auditLevel: row.auditLevel,
                    courseDept: row.xbdm,
                },
            }).then((res) => {
                if (res.data.data.state == 'success') {
                    this.auditFlowInfo = res.data.data.auditFlowInfo;
                } else {
                    this.auditFlowInfo = null;
                }

                this.selectRowData = row;
                this.auditListDialogVisible = true;
            }).catch((error) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        syncSchemeData() {
            this.showMaskLayer("人培方案信息同步中...");
            this.$api.common.dataExchange.scheme({
                data: {}
            }).then(response => {
                const state = res.data.data.state;
                const msg = res.data.data.msg;

                if (state == 'success') {
                    showNotify('成功', '同步成功', 'success', 1500);
                } else {
                    showNotify('错误', msg ? msg : '同步失败', 'error', 3000);
                }
                this.closeMaskLayer();
            }).catch(error => {
                console.log(error);
                this.closeMaskLayer();
            });
        },
        showMaskLayer(str) {
            this.syncDataMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        closeMaskLayer() {
            if (this.syncDataMask) this.syncDataMask.close();
        },
        // 中国标准时间 转换成 年月日
        formatDateTime(date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            var minute = date.getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            // return y + '-' + m + '-' + d+' '+h+':'+minute;
            return y + '-' + m + '-' + d;
        },
        getCurrentFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        createTeachingScheme() {
            this.$refs['createForm'].validate((valid) => {
                if (valid) {
                    this.createForm.glbjbh = this.createForm.glbjbh + '';
                    this.$api.teachingManage.teachingScheme.createTeachingScheme({
                        data: this.createForm,
                    }).then((res) => {
                        let state = res.data.data.state;
                        this.createBh = res.data.data.jpBh;
                        this.createGlbjbh = res.data.data.jpGlbjbh;

                        switch (state) {
                            case 'exist':
                                this.$alert('创建失败，已有同学年同专业、相同指定班级的人才培养方案！', '提示', {
                                    confirmButtonText: '确定'
                                });
                                break;
                            case 'success':
                                showNotify('成功', '新建成功', 'success', 1500);
                                this.queryList();

                                //获取专业名称
                                let schemeName = this.createForm.majorCode + '（' + this.createForm.majorCode + '）';
                                for (let i = 0; i < this.majorComboOption.length; i++) {
                                    if (this.createForm.majorCode === this.majorComboOption[i].comboValue) {
                                        schemeName = this.majorComboOption[i].comboName;
                                        break;
                                    }
                                }
                                const rowData = {
                                    jpBh: this.createBh,
                                    jpXn: this.createForm.workYear,
                                    jpZydm: this.createForm.majorCode,
                                    fullName: schemeName,
                                };
                                this.modRec(rowData);
                                this.createDialogVisivle = false;
                                break;
                            default:
                                showNotify('错误', '新建失败', 'error', 3000);
                                break;
                        }
                    }).catch((err) => {
                        showNotify('错误', '新建失败', err, 3000);
                    });
                } else {
                    return false;
                }
            });
        },
        closeCreateDialog() {
            if (this.$refs['createForm'] !== undefined) {
                this.$refs['createForm'].clearValidate();
                this.$refs['createForm'].resetFields();
            }
        },
        pubCourseConfig() {
            this.coursePreConfigDialogVisible = true;
        },
        importPubCourse() {
            this.courseImportDialogTitle = '公共课导入';
            this.courseImportDialogVisible = true;

            console.log(this.selectRowData);

            this.$nextTick().then(() => {
                this.$refs.courseImport.queryForm.year = this.selectRowData.jpXn;
                this.$refs.courseImport.queryForm.majorCode = this.selectRowData.jpZydm;
                this.$refs.courseImport.queryForm.courseType = '01';
            });
        },
        closeImportPubCourseDialog() {
            this.courseImportDialogVisible = false;
        },
        refreshInfo() {
            this.showDetailDialog(this.selectRowData);
            this.courseImportDialogVisible = false;
        },
        // 模板下载
        templetDownload() {
            const fileName = 'teachingProgressTemplate.xlsx'
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = "/static/template/" + fileName;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        //导入教学进程表
        importCAP() {
            this.importDialogVisible = true;
        },
        // 上传文件之前的钩子
        beforeUpload(file) {
            //判断文件格式
            let ext = file.name.split(".")[1]
            if (ext != 'xlsx' && ext != 'xls') {
                this.$message.error(`只能上传后缀为xls或xlsx的文件`);
                return false;
            }
            this.importButton = '正在处理中...';
            this.fileImporting = true;
            return true;
        },
        // 上传文件个数超过定义的数量
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
        },
        importTeachingProgress(fileObj) {
            if (this.ksnf == "") {
                this.$message({
                    title: '提示',
                    message: '请选择起效学年!',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }

            if (this.zydm == "") {
                this.$message({
                    title: '提示',
                    message: '请选择专业!',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }

            if (this.xz == "") {
                this.$message({
                    title: '提示',
                    message: '请输入学制!',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }

            confirmMsg('导入会覆盖已有数据，是否继续？').then(() => {
                this.showLoadingMask("教学进度表导入中，请稍候...");
                this.$api.teachingManage.teachingScheme.importTeachingProgress({
                    headers: {
                        "Content-Type": "multipart/form-data;charset=UTF-8",
                    },
                    data: {
                        file: fileObj.file,
                        'ksnf': this.ksnf,
                        'zydm': this.zydm,
                        'xz': this.xz,
                        'bh': this.createBh,
                    },
                }).then(response => {
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;

                    if (state == 'Success') {
                        this.$notify({
                            title: "成功",
                            message: msg ? msg : "保存成功",
                            type: "success",
                            duration: 1500,
                        });
                        this.refreshInfo();
                    } else {
                        this.errorMessage = msg;
                        this.errorDialogVisible = true;
                    }

                    this.closeLoadingMask();
                    this.importButton = '上传文件';
                    this.fileImporting = false;
                    this.importDialogVisible = false;
                }).catch(error => {
                    console.log(error);
                    this.closeLoadingMask();
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消导入'
                });
                this.closeLoadingMask();
            });
        },
        closeImportDialog() {
            this.importButton = '上传文件';
            this.importDialogVisible = false;
        },
        /**显示loading**/
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        closeErrorDialog() {
            this.errorMessage = '';
            this.errorDialogVisible = false;
        },
        exportCAP() {
            this.showLoadingMask("教学进度表导出中，请稍候...");

            let zymc = "";
            for (let i = 0; i < this.majorComboOption.length; i++) {
                if (this.zydm == this.majorComboOption[i].comboValue) {
                    zymc = this.majorComboOption[i].comboName;
                    break;
                }
            }

            const paramMap = {
                'qxxn': this.ksnf,
                'zydm': this.zydm,
                'zymc': zymc,
                'xz': this.xz,
            }
            this.$api.teachingManage.teachingScheme.exportTeachingProgress({
                data: paramMap,
                responseType: "blob",
            }).then((response) => {
                if (response.data.size == 0) {
                    this.$notify({
                        title: '提醒',
                        message: "查询不到教学进程表信息",
                        type: 'warning',
                        duration: 3000,
                    });
                } else {
                    const content = response.data;
                    const blob = new Blob([content]);

                    let year = new Date().getFullYear();//年
                    let month = new Date().getMonth() + 1;//注意！月份是从0月开始获取的，所以要+1;
                    let day = new Date().getDate();//日
                    //拼接日期
                    let yearMD = year + (month >= 10 ? month : '0' + month) + (day >= 10 ? day : '0' + day);

                    let xzmc = "";
                    if (parseFloat(this.xz) >= 5) {
                        xzmc = "（五年一贯制）";
                    } else {
                        xzmc = "（三年制）";
                    }

                    const fileName = this.ksnf + "级 " + zymc + "专业" + xzmc + "教学进程表" + yearMD + ".xlsx";
                    if ("download" in document.createElement("a")) {
                        // 非IE下载
                        const elink = document.createElement("a");
                        elink.download = fileName;
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    } else {
                        // IE10+下载
                        navigator.msSaveBlob(blob, fileName);
                    }
                }
                this.closeLoadingMask();
            }).catch((err) => {
                console.log(err);
            });
        },
        statisticCAP() {
            this.progressStatisticsDialogVisible = true;
        },
        closeProgressStatisticsDialog() {
            this.progressStatisticsDialogVisible = false;
        },

        //==============================================================================
        //审核后修改教学进程表部分
        showEditDetailDialog(rowData) {
            this.selectRowData_editScheme = rowData;
            this.jxjcForm.jjXn = this.selectRowData_editScheme.jpXn;
            this.jxjcForm.jjZydm = this.selectRowData_editScheme.jpZydm;
            this.queryForm.jpXn = this.selectRowData_editScheme.jpXn;
            this.queryJxjcForm.jjXn = this.selectRowData_editScheme.jpXn;
            this.queryJxjcForm.jjZydm = this.selectRowData_editScheme.jpZydm;

            if (this.selectRowData_editScheme == null) {
                this.$alert("请先选择一条记录", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }

            let zydm = this.selectRowData_editScheme.jpZydm;
            let obj = {};
            obj = this.majorComboOption.find((item) => {
                return item.comboValue === zydm;//筛选出匹配数据
            });
            this.jpZymc = obj.comboName;
            this.jxjcForm.jjZymc = obj.comboName;

            this.jxjcId = this.selectRowData_editScheme.jpBh;
            this.editSchemeDialogVisivle = true;

            this.queryJxjcbgList();
        },
        loadJXJCBInfo(id) {
            $('#loadingMask_edit').show();

            this.id = id;
            //this.$refs.comment.param.schemeId = this.id;
            let param = {
                schemeId: id,
            };

            this.$api.teachingManage.teachingScheme.loadInfo({
                data: param,
            }).then((res) => {
                let data = res.data;
                this.$refs.editCAP.CAPS = [];
                this.$refs.editCAP.CAPS = data.caps;
                this.$refs.editCAP.teachingSchemeCode = this.id;

                //this.loadParams(this.id);

                this.unlock();
                if (data.scheme.jpTjzt == "1") this.editDisableState = true;

                this.$nextTick(() => {
                    // 改变合计行样式
                    $(".el-table__footer-wrapper").css(
                        "font-weight",
                        "bold"
                    );
                    $(".el-table__footer-wrapper tr").css(
                        "font-weight",
                        "bold"
                    );

                    $('#loadingMask_edit').hide();
                });
            }).catch((err) => {
                this.unlock();
                console.log(err);
            });
        },
        queryJxjcbgList() {
            this.tableLoading = true;

            this.queryJxjcForm.res = this.currentPage_editScheme;
            this.queryJxjcForm.limit = this.limit_editScheme;
            this.$api.teachingManage.teachingScheme.queryJxjcbgList({
                data: this.queryJxjcForm,
            }).then((res) => {
                this.total_editScheme = res.data.data.total;
                this.editSchemeData = res.data.data.list;
                this.tableLoading = false;
            }).catch((err) => {
                this.tableLoading = false;
                console.log(err);
            });
        },
        rowClick_editScheme(row) {
            this.selectRowData_editScheme = row;
        },
        handleFilter_editScheme() {
            this.queryJxjcbgList();
        },
        handleReset_editScheme() {
            this.limit_editScheme = 10;
            this.currentPage_editScheme = 1;
            this.tableLoading = false;
            this.jxjcForm.jjZydm = null;
            this.jxjcForm.jjShzt = null;
            this.queryJxjcbgList();
        },
        handleSizeChange_editScheme(val) {
            this.limit_editScheme = val;
            this.queryJxjcbgList();
        },
        handlePageChange_editScheme(val) {
            this.currentPage_editScheme = val;
            this.queryJxjcbgList();
        },
        coursePropertiesChange(val) {
            this.jxjcForm.jjKcdm = '';
            this.editJxjcForm[0].jjKcsx = '';
            this.editJxjcForm[0].jjKcdm = '';
            this.loadCourseCombo(val, '');
        },
        courseInfoChange(val) {
            for (let i = 0; i < this.courseInfo.length; i++) {
                if (val == this.courseInfo[i].jjKcdm) {
                    this.editJxjcForm[0].jjKcmc = this.courseInfo[i].jjKcmc;
                    this.editJxjcForm[0].jjKclx = this.courseInfo[i].jjKclx;
                    this.editJxjcForm[0].jjKcsx = this.courseInfo[i].jjKcsx.split(",")[0];
                    this.editJxjcForm[0].jjXf = this.courseInfo[i].jjXf;
                    this.editJxjcForm[0].jjZxs = this.courseInfo[i].jjZxs;
                    this.editJxjcForm[0].jjLljx = this.courseInfo[i].jjLljx;
                    this.editJxjcForm[0].jjSysx = this.courseInfo[i].jjSysx;
                    break;
                }
            }

            this.kcsxInfo = [];
            if (this.courseInfo[0].jjKcsx != '') {
                let kcsxs = this.editJxjcForm[0].jjKcsx.split(",");
                for (let j = 0; j < this.kcsx.length; j++) {
                    for (let k = 0; k < kcsxs.length; k++) {
                        if (kcsxs[k] == this.kcsx[j].comboValue) {
                            this.kcsxInfo.push(this.kcsx[j]);
                        }
                    }
                }
            }
            this.kcsxholder = '请选择';
            this.kcsxDisabled = false;
        },
        loadCourseCombo(val, kcdm) {
            let param = {
                'kcsx': val,
            };
            this.$api.teachingManage.teachingScheme.loadCourseCombo({
                data: param,
            }).then((res) => {
                this.courseInfo = res.data.data.course;
                if ('' != kcdm) {
                    this.editJxjcForm[0].jjKcdm = kcdm;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        addJxjc() {
            this.jxjcTitle = '添加教学进程';
            this.editJxjcForm[0].saveType = "new";
            this.jxjcShow = 'change';
            this.jxjcHeight = '200px';

            this.editJxjcForm[0].jjKclx = '';
            this.editJxjcForm[0].jjKcdm = '';
            this.editJxjcForm[0].jjXf = '0';
            this.editJxjcForm[0].jjZxs = '0';
            this.editJxjcForm[0].isMajorcore = '0';
            this.editJxjcForm[0].isCertificate = '0';
            this.editJxjcForm[0].jjKhfs = '01';
            this.editJxjcForm[0].jjLljx = '0';
            this.editJxjcForm[0].jjSysx = '0';
            this.editJxjcForm[0].jjXq1 = '0';
            this.editJxjcForm[0].jjXq2 = '0';
            this.editJxjcForm[0].jjXq3 = '0';
            this.editJxjcForm[0].jjXq4 = '0';
            this.editJxjcForm[0].jjXq5 = '0';
            this.editJxjcForm[0].jjXq6 = '0';
            this.editJxjcForm[0].jjXq7 = '0';
            this.editJxjcForm[0].jjXq8 = '0';
            this.editJxjcForm[0].jjXq9 = '0';
            this.editJxjcForm[0].jjXq10 = '0';
            this.editJxjcForm[0].jjZs1 = '0';
            this.editJxjcForm[0].jjZs2 = '0';
            this.editJxjcForm[0].jjZs3 = '0';
            this.editJxjcForm[0].jjZs4 = '0';
            this.editJxjcForm[0].jjZs5 = '0';
            this.editJxjcForm[0].jjZs6 = '0';
            this.editJxjcForm[0].jjZs7 = '0';
            this.editJxjcForm[0].jjZs8 = '0';
            this.editJxjcForm[0].jjZs9 = '0';
            this.editJxjcForm[0].jjZs10 = '0';
            this.editJxjcForm[0].jjBz = '';

            if (this.$refs['editJxjcForm']) {
                this.$refs['editJxjcForm'].clearValidate();
            }
            this.jxjcDialogVisible = true;
        },
        editJxjc() {
            this.jxjcTitle = '修改教学进程';
            this.editJxjcForm[0].saveType = "new";
            this.jxjcShow = 'change';
            this.jxjcHeight = '100px';

            this.editJxjcForm[0].jjKclx = '';
            this.editJxjcForm[0].jjKcdm = '';
            this.editJxjcForm[0].jjXf = '0';
            this.editJxjcForm[0].jjZxs = '0';
            this.editJxjcForm[0].isMajorcore = '0';
            this.editJxjcForm[0].isCertificate = '0';
            this.editJxjcForm[0].jjKhfs = '01';
            this.editJxjcForm[0].jjLljx = '0';
            this.editJxjcForm[0].jjSysx = '0';
            this.editJxjcForm[0].jjXq1 = '0';
            this.editJxjcForm[0].jjXq2 = '0';
            this.editJxjcForm[0].jjXq3 = '0';
            this.editJxjcForm[0].jjXq4 = '0';
            this.editJxjcForm[0].jjXq5 = '0';
            this.editJxjcForm[0].jjXq6 = '0';
            this.editJxjcForm[0].jjXq7 = '0';
            this.editJxjcForm[0].jjXq8 = '0';
            this.editJxjcForm[0].jjXq9 = '0';
            this.editJxjcForm[0].jjXq10 = '0';
            this.editJxjcForm[0].jjZs1 = '0';
            this.editJxjcForm[0].jjZs2 = '0';
            this.editJxjcForm[0].jjZs3 = '0';
            this.editJxjcForm[0].jjZs4 = '0';
            this.editJxjcForm[0].jjZs5 = '0';
            this.editJxjcForm[0].jjZs6 = '0';
            this.editJxjcForm[0].jjZs7 = '0';
            this.editJxjcForm[0].jjZs8 = '0';
            this.editJxjcForm[0].jjZs9 = '0';
            this.editJxjcForm[0].jjZs10 = '0';
            this.editJxjcForm[0].jjBz = '';

            if (this.$refs['editJxjcForm']) {
                this.$refs['editJxjcForm'].clearValidate();
            }
            this.jxjcDialogVisible = true;
        },
        delJxjc() {
            this.jxjcTitle = '删除教学进程';
            this.editJxjcForm[0].saveType = "new";
            this.jxjcShow = 'show';
            this.jxjcHeight = '200px';

            if (this.$refs['editJxjcForm']) {
                this.$refs['editJxjcForm'].clearValidate();
            }
            this.jxjcDialogVisible = true;
        },
        modRec_jxjc(row) {
            this.editJxjcForm[0].saveType = "edit";
            this.jxjcHeight = '100px';
            if (row.jjJxjcbh != '') {
                this.queryOldJxjcInfo();
            }
            this.getJxjcbgInfo(row);
            this.kcsxDisabled = false;
            this.jxjcDialogVisible = true;
        },
        delRec_jxjc(row) {
            confirmMsg('此操作将删除该教学进程变更信息，是否继续？').then(() => {
                let param = {
                    'jjBh': row.jjBh,
                };
                this.$api.teachingManage.teachingScheme.deleteJxjcbgById({
                    data: param,
                }).then((response) => {
                    showNotify('成功', '删除成功', 'success', 1500);
                    this.queryJxjcbgList();
                }).catch((error) => {
                    this.formSubmiting = false;
                    showNotify('错误', error, 'error', 3000);
                });
            });
        },
        showRec_jxjc(row) {
            this.selectRowData_editScheme = row;
            this.jxjcTitle = '详情';
            this.editJxjcForm[0].saveType = "show";
            this.editJxjcForm[0].jjBglx = row.jjBglx;
            if (row.jjJxjcbh != '') {
                this.queryOldJxjcInfo();
            }
            this.getJxjcbgInfo(row);
            this.jxjcCompareDialogVisible = true;
        },
        queryOldJxjcInfo(jjJxjcbh) {
            const paramMap = {
                'jjBh': jjJxjcbh,
            }
            this.$api.teachingManage.teachingScheme.queryOldJxjcInfo({
                data: paramMap,
            }).then((res) => {
                this.oldJxjcData = res.data.data.list;
                this.getOldJxjcInfo(this.oldJxjcData[0]);
            }).catch((err) => {
                console.log(err);
            });
        },
        auditRec_jxjc(row) {
            this.selectRowData_editScheme = row;
            this.jxjcTitle = '审核';
            this.editjxjcForm[0].saveType = "audit";
            this.getJxjcbgInfo(row);
            this.jxjcCompareDialogVisible = true;
        },
        auditOption() {
            this.jxjcbgDialogVisible = true;
        },
        //审核后回调函数
        auditCallback_jxjc(auditInfo) {
            this.jxjcbgDialogVisible = false;
            this.updateAuditState_jxjc(auditInfo);
        },
        //完成审核后更新审核状态
        updateAuditState_jxjc(auditInfo) {
            this.$api.teachingManage.teachingScheme.updateAuditState_jxjc({
                data: auditInfo,
            }).then((response) => {
                let state = response.data.data.state;
                if (state == 'Success') {
                    this.queryJxjcbgList();
                    this.jxjcDialogVisible = false;
                } else {
                    showNotify('错误', '审核状态更新失败', 'error', 3000);
                }
            }).catch((error) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        //审状态列样式处理
        handleCellStyle_jxjc({row, column, rowIndex, columnIndex}) {
            let cellStyle;

            if (columnIndex === 6) {
                switch (row.jjTjzt) {
                    case '-2':
                        cellStyle = 'color: #e6a23c !important;';
                        break;
                    case '-1':
                        cellStyle = 'color: #409eff !important;';
                        break;
                    case '0':
                        cellStyle = 'color: #808080 !important;';
                        break;
                    case '1':
                        cellStyle = 'color: #00FF40 !important;';
                        break;
                    case '2':
                        cellStyle = 'color: #FE2E2E !important;';
                        break;
                    default:
                        cellStyle = '';
                }

                return cellStyle;
            }
        },
        //显示审核详情列表
        showAuditList_jxjc(row) {
            this.selectRowData_editScheme = row;
            this.jxjcbgListDialogVisible = true;
        },
        openScheme() {
            this.loadJXJCBInfo(this.jxjcId);
            this.showSchemeDialogVisivle = true;
        },
        getJxjcInfo(row) {
            this.jxjcForm.jjJxjcbh = row.bh;
            this.jxjcForm.jjBglx = row.jjBglx;
            this.jxjcForm.jjKclx = row.courseKind;
            this.jxjcForm.jjKcsx = row.courseProperties;
            let obj = {};
            if (row.courseProperties != '' && row.courseProperties != null) {
                obj = this.kcsxInfo.find((item) => {
                    return item.comboValue === row.courseProperties;//筛选出匹配数据
                });
                this.jxjcForm.jjKcsxmc = obj.comboName;
            }
            this.loadCourseCombo(row.courseKind, row.courseId);
            this.$nextTick(() => {
                this.jxjcForm.jjJxjckcdm = row.courseId;
                this.jxjcForm.jjJxjckcmc = row.courseName;
                this.jxjcForm.jjKcdm = row.courseId;
                this.jxjcForm.jjKcmc = row.courseName;
            });
            this.jxjcForm.jjZxs = row.totalTime;
            this.jxjcForm.jjXf = row.score;
            this.jxjcForm.jjKhfs = row.examType;
            if (row.examType != '') {
                obj = {};
                obj = this.assessFormInfo.find((item) => {
                    return item.comboValue === row.examType;//筛选出匹配数据
                });
                this.jxjcForm.jjKhfsmc = obj.comboName;
            }

            this.jxjcForm.isMajorcore = row.isMajorcore;
            this.jxjcForm.isMajorcoreName = row.isMajorcoreName;
            this.jxjcForm.isCertificate = row.isCertificate;
            this.jxjcForm.isCertificateName = row.isCertificateName;

            this.jxjcForm.jjLljx = row.theoryTime;
            this.jxjcForm.jjSysx = row.practiseTime;
            this.jxjcForm.jjXq1 = row.term1;
            this.jxjcForm.jjXq2 = row.term2;
            this.jxjcForm.jjXq3 = row.term3;
            this.jxjcForm.jjXq4 = row.term4;
            this.jxjcForm.jjXq5 = row.term5;
            this.jxjcForm.jjXq6 = row.term6;
            this.jxjcForm.jjXq7 = row.term7;
            this.jxjcForm.jjXq8 = row.term8;
            this.jxjcForm.jjXq9 = row.term9;
            this.jxjcForm.jjXq10 = row.term10;
            this.jxjcForm.jjZs1 = row.week1;
            this.jxjcForm.jjZs2 = row.week2;
            this.jxjcForm.jjZs3 = row.week3;
            this.jxjcForm.jjZs4 = row.week4;
            this.jxjcForm.jjZs5 = row.week5;
            this.jxjcForm.jjZs6 = row.week6;
            this.jxjcForm.jjZs7 = row.week7;
            this.jxjcForm.jjZs8 = row.week8;
            this.jxjcForm.jjZs9 = row.week9;
            this.jxjcForm.jjZs10 = row.week10;

            if (this.jxjcTitle == '修改教学进程' || this.jxjcTitle == '删除教学进程') {//显示
                this.oldJxjcForm[0].jjJxjcbh = row.bh;
                this.oldJxjcForm[0].jjBglx = row.jjBglx;
                this.oldJxjcForm[0].jjKclx = row.courseKind;
                this.oldJxjcForm[0].jjKcsx = row.courseProperties;
                let obj = {};
                if (row.jjKcsx != '' && row.jjKcsx != null) {
                    obj = this.kcsxInfo.find((item) => {
                        return item.comboValue === row.courseProperties;//筛选出匹配数据
                    });
                    this.oldJxjcForm[0].jjKcsxmc = obj.comboName;
                }

                this.$nextTick(() => {
                    this.oldJxjcForm[0].jjJxjckcdm = row.courseId;
                    this.oldJxjcForm[0].jjJxjckcmc = row.courseName;
                    this.oldJxjcForm[0].jjKcdm = row.courseId;
                    this.oldJxjcForm[0].jjKcmc = row.courseName;
                });
                this.oldJxjcForm[0].jjZxs = row.totalTime;
                this.oldJxjcForm[0].jjXf = row.score;
                this.oldJxjcForm[0].jjKhfs = row.examType;
                if (row.examType != '') {
                    obj = {};
                    obj = this.assessFormInfo.find((item) => {
                        return item.comboValue === row.examType;//筛选出匹配数据
                    });
                    this.oldJxjcForm[0].jjKhfsmc = obj.comboName;
                }

                this.oldJxjcForm[0].isMajorcore = row.isMajorcore;
                this.oldJxjcForm[0].isMajorcoreName = row.isMajorcoreName;
                this.oldJxjcForm[0].isCertificate = row.isCertificate;
                this.oldJxjcForm[0].isCertificateName = row.isCertificateName;

                this.oldJxjcForm[0].jjLljx = row.theoryTime;
                this.oldJxjcForm[0].jjSysx = row.practiseTime;
                this.oldJxjcForm[0].jjXq1 = row.term1;
                this.oldJxjcForm[0].jjXq2 = row.term2;
                this.oldJxjcForm[0].jjXq3 = row.term3;
                this.oldJxjcForm[0].jjXq4 = row.term4;
                this.oldJxjcForm[0].jjXq5 = row.term5;
                this.oldJxjcForm[0].jjXq6 = row.term6;
                this.oldJxjcForm[0].jjXq7 = row.term7;
                this.oldJxjcForm[0].jjXq8 = row.term8;
                this.oldJxjcForm[0].jjXq9 = row.term9;
                this.oldJxjcForm[0].jjXq10 = row.term10;
                this.oldJxjcForm[0].jjZs1 = row.week1;
                this.oldJxjcForm[0].jjZs2 = row.week2;
                this.oldJxjcForm[0].jjZs3 = row.week3;
                this.oldJxjcForm[0].jjZs4 = row.week4;
                this.oldJxjcForm[0].jjZs5 = row.week5;
                this.oldJxjcForm[0].jjZs6 = row.week6;
                this.oldJxjcForm[0].jjZs7 = row.week7;
                this.oldJxjcForm[0].jjZs8 = row.week8;
                this.oldJxjcForm[0].jjZs9 = row.week9;
                this.oldJxjcForm[0].jjZs10 = row.week10;

                //保存内容
                this.editJxjcForm[0].jjJxjcbh = row.bh;
                this.editJxjcForm[0].jjBglx = row.jjBglx;
                this.editJxjcForm[0].jjKclx = row.courseKind;
                this.editJxjcForm[0].jjKcsx = row.courseProperties;
                obj = {};
                if (row.jjKcsx != '' && row.jjKcsx != null) {
                    obj = this.kcsxInfo.find((item) => {
                        return item.comboValue === row.courseProperties;//筛选出匹配数据
                    });
                    this.editJxjcForm[0].jjKcsxmc = obj.comboName;
                }

                this.$nextTick(() => {
                    this.editJxjcForm[0].jjJxjckcdm = row.courseId;
                    this.editJxjcForm[0].jjJxjckcmc = row.courseName;
                    this.editJxjcForm[0].jjKcdm = row.courseId;
                    this.editJxjcForm[0].jjKcmc = row.courseName;
                });
                this.editJxjcForm[0].jjZxs = row.totalTime;
                this.editJxjcForm[0].jjXf = row.score;
                this.editJxjcForm[0].jjKhfs = row.examType;
                if (row.examType != '') {
                    obj = {};
                    obj = this.assessFormInfo.find((item) => {
                        return item.comboValue === row.examType;//筛选出匹配数据
                    });
                    this.editJxjcForm[0].jjKhfsmc = obj.comboName;
                }

                this.editJxjcForm[0].isMajorcore = row.isMajorcore;
                this.editJxjcForm[0].isMajorcoreName = row.isMajorcoreName;
                this.editJxjcForm[0].isCertificate = row.isCertificate;
                this.editJxjcForm[0].isCertificateName = row.isCertificateName;

                this.editJxjcForm[0].jjLljx = row.theoryTime;
                this.editJxjcForm[0].jjSysx = row.practiseTime;
                this.editJxjcForm[0].jjXq1 = row.term1;
                this.editJxjcForm[0].jjXq2 = row.term2;
                this.editJxjcForm[0].jjXq3 = row.term3;
                this.editJxjcForm[0].jjXq4 = row.term4;
                this.editJxjcForm[0].jjXq5 = row.term5;
                this.editJxjcForm[0].jjXq6 = row.term6;
                this.editJxjcForm[0].jjXq7 = row.term7;
                this.editJxjcForm[0].jjXq8 = row.term8;
                this.editJxjcForm[0].jjXq9 = row.term9;
                this.editJxjcForm[0].jjXq10 = row.term10;
                this.editJxjcForm[0].jjZs1 = row.week1;
                this.editJxjcForm[0].jjZs2 = row.week2;
                this.editJxjcForm[0].jjZs3 = row.week3;
                this.editJxjcForm[0].jjZs4 = row.week4;
                this.editJxjcForm[0].jjZs5 = row.week5;
                this.editJxjcForm[0].jjZs6 = row.week6;
                this.editJxjcForm[0].jjZs7 = row.week7;
                this.editJxjcForm[0].jjZs8 = row.week8;
                this.editJxjcForm[0].jjZs9 = row.week9;
                this.editJxjcForm[0].jjZs10 = row.week10;
            }
            this.showSchemeDialogVisivle = false;
        },
        getJxjcbgInfo(row) {
            if (this.jxjcTitle == '审核') {
                this.jxjcShow = 'show';
            } else if (this.jxjcTitle == '详情') {
                this.jxjcShow = 'show';
            } else {
                this.jxjcTitle = row.jjBglxmc + '教学进程';
                if (row.jjBglx == '3') {
                    this.jxjcShow = 'show';
                } else {
                    this.jxjcShow = '';
                }
            }
            //=========================================编辑
            this.jxjcForm.jjBh = row.jjBh;
            this.jxjcForm.jjJxjcbh = row.jjJxjcbh;
            this.jxjcForm.jjBglx = row.jjBglx;
            this.jxjcForm.jjKclx = row.jjKclx;
            let obj = {};
            if (row.jjKclx != '' && row.jjKclx != null) {
                obj = this.kclxInfo.find((item) => {
                    return item.comboValue === row.jjKclx;//筛选出匹配数据
                });
                this.jxjcForm.jjKclxmc = obj.comboName;
            }
            this.jxjcForm.jjKcsx = row.jjKcsx;
            obj = {};
            if (row.jjKcsx != '' && row.jjKcsx != null) {
                obj = this.kcsxInfo.find((item) => {
                    return item.comboValue === row.jjKcsx;//筛选出匹配数据
                });
                this.jxjcForm.jjKcsxmc = obj.comboName;
            }
            this.loadCourseCombo(row.jjKclx, row.jjKcdm);
            this.$nextTick(() => {
                this.jxjcForm.jjJxjckcdm = row.jjJxjckcdm;
                this.jxjcForm.jjJxjckcmc = row.jjJxjckcmc;
                this.jxjcForm.jjKcdm = row.jjKcdm;
                this.jxjcForm.jjKcmc = row.jjKcmc;
            });
            this.jxjcForm.jjZxs = row.jjZxs;
            this.jxjcForm.jjXf = row.jjXf;
            this.jxjcForm.jjKhfs = row.jjKhfs;
            if (row.jjKhfs != '') {
                obj = {};
                obj = this.assessFormInfo.find((item) => {
                    return item.comboValue === row.jjKhfs;//筛选出匹配数据
                });
                this.jxjcForm.jjKhfsmc = obj.comboName;
            }

            this.jxjcForm.isMajorcore = row.isMajorcore;
            this.jxjcForm.isMajorcoreName = row.isMajorcoreName;
            this.jxjcForm.isCertificate = row.isCertificate;
            this.jxjcForm.isCertificateName = row.isCertificateName;

            this.jxjcForm.jjLljx = row.jjLljx;
            this.jxjcForm.jjSysx = row.jjSysx;
            this.jxjcForm.jjXq1 = row.jjXq1;
            this.jxjcForm.jjXq2 = row.jjXq2;
            this.jxjcForm.jjXq3 = row.jjXq3;
            this.jxjcForm.jjXq4 = row.jjXq4;
            this.jxjcForm.jjXq5 = row.jjXq5;
            this.jxjcForm.jjXq6 = row.jjXq6;
            this.jxjcForm.jjXq7 = row.jjXq7;
            this.jxjcForm.jjXq8 = row.jjXq8;
            this.jxjcForm.jjXq9 = row.jjXq9;
            this.jxjcForm.jjXq10 = row.jjXq10;
            this.jxjcForm.jjZs1 = row.jjZs1;
            this.jxjcForm.jjZs2 = row.jjZs2;
            this.jxjcForm.jjZs3 = row.jjZs3;
            this.jxjcForm.jjZs4 = row.jjZs4;
            this.jxjcForm.jjZs5 = row.jjZs5;
            this.jxjcForm.jjZs6 = row.jjZs6;
            this.jxjcForm.jjZs7 = row.jjZs7;
            this.jxjcForm.jjZs8 = row.jjZs8;
            this.jxjcForm.jjZs9 = row.jjZs9;
            this.jxjcForm.jjZs10 = row.jjZs10;

            //===================================================================
            this.editJxjcForm[0].jjBh = row.jjBh;
            this.editJxjcForm[0].jjJxjcbh = row.jjJxjcbh;
            this.editJxjcForm[0].jjBglx = row.jjBglx;
            this.editJxjcForm[0].jjKclx = row.jjKclx;
            obj = {};
            if (row.jjKclx != '' && row.jjKclx != null) {
                obj = this.kclxInfo.find((item) => {
                    return item.comboValue === row.jjKclx;//筛选出匹配数据
                });
                this.editJxjcForm[0].jjKclxmc = obj.comboName;
            }
            this.editJxjcForm[0].jjKcsx = row.jjKcsx;
            obj = {};
            if (row.jjKcsx != '' && row.jjKcsx != null) {
                obj = this.kcsxInfo.find((item) => {
                    return item.comboValue === row.jjKcsx;//筛选出匹配数据
                });
                this.editJxjcForm[0].jjKcsxmc = obj.comboName;
            }

            this.$nextTick(() => {
                this.editJxjcForm[0].jjJxjckcdm = row.jjJxjckcdm;
                this.editJxjcForm[0].jjJxjckcmc = row.jjJxjckcmc;
                this.editJxjcForm[0].jjKcdm = row.jjKcdm;
                this.editJxjcForm[0].jjKcmc = row.jjKcmc;
            });
            this.editJxjcForm[0].jjZxs = row.jjZxs;
            this.editJxjcForm[0].jjXf = row.jjXf;
            this.editJxjcForm[0].jjKhfs = row.jjKhfs;
            if (row.jjKhfs != '') {
                obj = {};
                obj = this.assessFormInfo.find((item) => {
                    return item.comboValue === row.jjKhfs;//筛选出匹配数据
                });
                this.editJxjcForm[0].jjKhfsmc = obj.comboName;
            }

            this.editJxjcForm[0].isMajorcore = row.isMajorcore;
            this.editJxjcForm[0].isMajorcoreName = row.isMajorcoreName;
            this.editJxjcForm[0].isCertificate = row.isCertificate;
            this.editJxjcForm[0].isCertificateName = row.isCertificateName;

            this.editJxjcForm[0].jjLljx = row.jjLljx;
            this.editJxjcForm[0].jjSysx = row.jjSysx;
            this.editJxjcForm[0].jjXq1 = row.jjXq1;
            this.editJxjcForm[0].jjXq2 = row.jjXq2;
            this.editJxjcForm[0].jjXq3 = row.jjXq3;
            this.editJxjcForm[0].jjXq4 = row.jjXq4;
            this.editJxjcForm[0].jjXq5 = row.jjXq5;
            this.editJxjcForm[0].jjXq6 = row.jjXq6;
            this.editJxjcForm[0].jjXq7 = row.jjXq7;
            this.editJxjcForm[0].jjXq8 = row.jjXq8;
            this.editJxjcForm[0].jjXq9 = row.jjXq9;
            this.editJxjcForm[0].jjXq10 = row.jjXq10;
            this.editJxjcForm[0].jjZs1 = row.jjZs1;
            this.editJxjcForm[0].jjZs2 = row.jjZs2;
            this.editJxjcForm[0].jjZs3 = row.jjZs3;
            this.editJxjcForm[0].jjZs4 = row.jjZs4;
            this.editJxjcForm[0].jjZs5 = row.jjZs5;
            this.editJxjcForm[0].jjZs6 = row.jjZs6;
            this.editJxjcForm[0].jjZs7 = row.jjZs7;
            this.editJxjcForm[0].jjZs8 = row.jjZs8;
            this.editJxjcForm[0].jjZs9 = row.jjZs9;
            this.editJxjcForm[0].jjZs10 = row.jjZs10;

            //============================================审核，查看
            this.newJxjcForm[0].jjBh = row.jjBh;
            this.newJxjcForm[0].jjJxjcbh = row.jjJxjcbh;
            this.newJxjcForm[0].jjBglx = row.jjBglx;
            this.newJxjcForm[0].jjKclx = row.jjKclx;
            this.newJxjcForm[0].jjKcsx = row.jjKcsx;
            obj = {};
            if (row.jjKcsx != '' && row.jjKcsx != null) {
                obj = this.kcsxInfo.find((item) => {
                    return item.comboValue === row.jjKcsx;//筛选出匹配数据
                });
                this.newJxjcForm[0].jjKcsxmc = obj.comboName;
            }
            this.loadCourseCombo(row.jjKclx, row.jjKcdm);
            this.$nextTick(() => {
                this.newJxjcForm[0].jjJxjckcdm = row.jjJxjckcdm;
                this.newJxjcForm[0].jjJxjckcmc = row.jjJxjckcmc;
                this.newJxjcForm[0].jjKcdm = row.jjKcdm;
                this.newJxjcForm[0].jjKcmc = row.jjKcmc;
            });
            this.newJxjcForm[0].jjZxs = row.jjZxs;
            this.newJxjcForm[0].jjXf = row.jjXf;
            this.newJxjcForm[0].jjKhfs = row.jjKhfs;
            if (row.jjKhfs != '') {
                obj = {};
                obj = this.assessFormInfo.find((item) => {
                    return item.comboValue === row.jjKhfs;//筛选出匹配数据
                });
                this.newJxjcForm[0].jjKhfsmc = obj.comboName;
            }

            this.newJxjcForm[0].isMajorcore = row.isMajorcore;
            this.newJxjcForm[0].isMajorcoreName = row.isMajorcoreName;
            this.newJxjcForm[0].isCertificate = row.isCertificate;
            this.newJxjcForm[0].isCertificateName = row.isCertificateName;

            this.newJxjcForm[0].jjLljx = row.jjLljx;
            this.newJxjcForm[0].jjSysx = row.jjSysx;
            this.newJxjcForm[0].jjXq1 = row.jjXq1;
            this.newJxjcForm[0].jjXq2 = row.jjXq2;
            this.newJxjcForm[0].jjXq3 = row.jjXq3;
            this.newJxjcForm[0].jjXq4 = row.jjXq4;
            this.newJxjcForm[0].jjXq5 = row.jjXq5;
            this.newJxjcForm[0].jjXq6 = row.jjXq6;
            this.newJxjcForm[0].jjXq7 = row.jjXq7;
            this.newJxjcForm[0].jjXq8 = row.jjXq8;
            this.newJxjcForm[0].jjXq9 = row.jjXq9;
            this.newJxjcForm[0].jjXq10 = row.jjXq10;
            this.newJxjcForm[0].jjZs1 = row.jjZs1;
            this.newJxjcForm[0].jjZs2 = row.jjZs2;
            this.newJxjcForm[0].jjZs3 = row.jjZs3;
            this.newJxjcForm[0].jjZs4 = row.jjZs4;
            this.newJxjcForm[0].jjZs5 = row.jjZs5;
            this.newJxjcForm[0].jjZs6 = row.jjZs6;
            this.newJxjcForm[0].jjZs7 = row.jjZs7;
            this.newJxjcForm[0].jjZs8 = row.jjZs8;
            this.newJxjcForm[0].jjZs9 = row.jjZs9;
            this.newJxjcForm[0].jjZs10 = row.jjZs10;

            this.showSchemeDialogVisivle = false;
        },
        getOldJxjcInfo(row) {
            if (row.jjBglx == '1' || row.jjBglx == '3') {
                this.newJxjcForm[0].jjJxjcbh = row.jjBh;
                this.newJxjcForm[0].jjKclx = row.jjKclx;
                let obj = {};
                if (row.jjKclx != '' && row.jjKclx != null) {
                    obj = this.kclxInfo.find((item) => {
                        return item.comboValue === row.jjKclx;//筛选出匹配数据
                    });
                    this.newJxjcForm[0].jjKclxmc = obj.comboName;
                }
                this.newJxjcForm[0].jjKcsx = row.jjKcsx;
                obj = {};
                if (row.jjKcsx != '' && row.jjKcsx != null) {
                    obj = this.kcsxInfo.find((item) => {
                        return item.comboValue === row.jjKcsx;//筛选出匹配数据
                    });
                    this.newJxjcForm[0].jjKcsxmc = obj.comboName;
                }
                this.$nextTick(() => {
                    this.newJxjcForm[0].jjKcdm = row.jjKcdm;
                    this.newJxjcForm[0].jjKcmc = row.jjKcmc;
                });
                this.newJxjcForm[0].jjZxs = row.jjZxs;
                this.newJxjcForm[0].jjXf = row.jjXf;

                this.newJxjcForm[0].jjKhfs = row.jjKhfs;
                if (row.jjKhfs != '') {
                    obj = {};
                    obj = this.assessFormInfo.find((item) => {
                        return item.comboValue === row.jjKhfs;//筛选出匹配数据
                    });
                    this.newJxjcForm[0].jjKhfsmc = obj.comboName;
                }

                this.newJxjcForm[0].isMajorcore = row.isMajorcore;
                this.newJxjcForm[0].isMajorcoreName = row.isMajorcoreName;
                this.newJxjcForm[0].isCertificate = row.isCertificate;
                this.newJxjcForm[0].isCertificateName = row.isCertificateName;

                this.newJxjcForm[0].jjLljx = row.jjLljx;
                this.newJxjcForm[0].jjSysx = row.jjSysx;
                this.newJxjcForm[0].jjXq1 = row.jjXq1;
                this.newJxjcForm[0].jjXq2 = row.jjXq2;
                this.newJxjcForm[0].jjXq3 = row.jjXq3;
                this.newJxjcForm[0].jjXq4 = row.jjXq4;
                this.newJxjcForm[0].jjXq5 = row.jjXq5;
                this.newJxjcForm[0].jjXq6 = row.jjXq6;
                this.newJxjcForm[0].jjXq7 = row.jjXq7;
                this.newJxjcForm[0].jjXq8 = row.jjXq8;
                this.newJxjcForm[0].jjXq9 = row.jjXq9;
                this.newJxjcForm[0].jjXq10 = row.jjXq10;
                this.newJxjcForm[0].jjZs1 = row.jjZs1;
                this.newJxjcForm[0].jjZs2 = row.jjZs2;
                this.newJxjcForm[0].jjZs3 = row.jjZs3;
                this.newJxjcForm[0].jjZs4 = row.jjZs4;
                this.newJxjcForm[0].jjZs5 = row.jjZs5;
                this.newJxjcForm[0].jjZs6 = row.jjZs6;
                this.newJxjcForm[0].jjZs7 = row.jjZs7;
                this.newJxjcForm[0].jjZs8 = row.jjZs8;
                this.newJxjcForm[0].jjZs9 = row.jjZs9;
                this.newJxjcForm[0].jjZs10 = row.jjZs10;
            } else {
                this.oldJxjcForm[0].jjJxjcbh = row.jjBh;
                this.oldJxjcForm[0].jjKclx = row.jjKclx;
                let obj = {};
                if (row.jjKclx != '' && row.jjKclx != null) {
                    obj = this.kclxInfo.find((item) => {
                        return item.comboValue === row.jjKclx;//筛选出匹配数据
                    });
                    this.oldJxjcForm[0].jjKclxmc = obj.comboName;
                }
                this.oldJxjcForm[0].jjKcsx = row.jjKcsx;
                obj = {};
                if (row.jjKcsx != '' && row.jjKcsx != null) {
                    obj = this.kcsxInfo.find((item) => {
                        return item.comboValue === row.jjKcsx;//筛选出匹配数据
                    });
                    this.oldJxjcForm[0].jjKcsxmc = obj.comboName;
                }
                this.$nextTick(() => {
                    this.oldJxjcForm[0].jjKcdm = row.jjKcdm;
                    this.oldJxjcForm[0].jjKcmc = row.jjKcmc;
                });
                this.oldJxjcForm[0].jjZxs = row.jjZxs;
                this.oldJxjcForm[0].jjXf = row.jjXf;

                this.oldJxjcForm[0].jjKhfs = row.jjKhfs;
                if (row.jjKhfs != '') {
                    obj = {};
                    obj = this.assessFormInfo.find((item) => {
                        return item.comboValue === row.jjKhfs;//筛选出匹配数据
                    });
                    this.oldJxjcForm[0].jjKhfsmc = obj.comboName;
                }

                this.oldJxjcForm[0].isMajorcore = row.isMajorcore;
                this.oldJxjcForm[0].isMajorcoreName = row.isMajorcoreName;
                this.oldJxjcForm[0].isCertificate = row.isCertificate;
                this.oldJxjcForm[0].isCertificateName = row.isCertificateName;

                this.oldJxjcForm[0].jjLljx = row.jjLljx;
                this.oldJxjcForm[0].jjSysx = row.jjSysx;
                this.oldJxjcForm[0].jjXq1 = row.jjXq1;
                this.oldJxjcForm[0].jjXq2 = row.jjXq2;
                this.oldJxjcForm[0].jjXq3 = row.jjXq3;
                this.oldJxjcForm[0].jjXq4 = row.jjXq4;
                this.oldJxjcForm[0].jjXq5 = row.jjXq5;
                this.oldJxjcForm[0].jjXq6 = row.jjXq6;
                this.oldJxjcForm[0].jjXq7 = row.jjXq7;
                this.oldJxjcForm[0].jjXq8 = row.jjXq8;
                this.oldJxjcForm[0].jjXq9 = row.jjXq9;
                this.oldJxjcForm[0].jjXq10 = row.jjXq10;
                this.oldJxjcForm[0].jjZs1 = row.jjZs1;
                this.oldJxjcForm[0].jjZs2 = row.jjZs2;
                this.oldJxjcForm[0].jjZs3 = row.jjZs3;
                this.oldJxjcForm[0].jjZs4 = row.jjZs4;
                this.oldJxjcForm[0].jjZs5 = row.jjZs5;
                this.oldJxjcForm[0].jjZs6 = row.jjZs6;
                this.oldJxjcForm[0].jjZs7 = row.jjZs7;
                this.oldJxjcForm[0].jjZs8 = row.jjZs8;
                this.oldJxjcForm[0].jjZs9 = row.jjZs9;
                this.oldJxjcForm[0].jjZs10 = row.jjZs10;
            }

        },
        closeJxjcDialog() {
            this.jxjcForm.jjBglx = null;
            this.jxjcForm.jjJxjcbh = '';
            this.jxjcForm.jjJxjckcdm = '';
            this.jxjcForm.jjJxjckcmc = '';
            this.jxjcForm.jjPyfabh = null;
            this.jxjcForm.jjKcdm = null;
            this.jxjcForm.jjKcmc = null;
            this.jxjcForm.jjKclx = null;
            this.jxjcForm.jjKcsx = null;
            this.jxjcForm.isMajorcore = null;
            this.jxjcForm.isCertificate = null;
            this.jxjcForm.jjZxs = 0;
            this.jxjcForm.jjXf = 0;
            this.jxjcForm.jjKhfs = null;
            this.jxjcForm.jjLljx = 0;
            this.jxjcForm.jjSysx = 0;
            this.jxjcForm.jjXq1 = 0;
            this.jxjcForm.jjXq2 = 0;
            this.jxjcForm.jjXq3 = 0;
            this.jxjcForm.jjXq4 = 0;
            this.jxjcForm.jjXq5 = 0;
            this.jxjcForm.jjXq6 = 0;
            this.jxjcForm.jjXq7 = 0;
            this.jxjcForm.jjXq8 = 0;
            this.jxjcForm.jjXq9 = 0;
            this.jxjcForm.jjXq10 = 0;
            this.jxjcForm.jjZs1 = 0;
            this.jxjcForm.jjZs2 = 0;
            this.jxjcForm.jjZs3 = 0;
            this.jxjcForm.jjZs4 = 0;
            this.jxjcForm.jjZs5 = 0;
            this.jxjcForm.jjZs6 = 0;
            this.jxjcForm.jjZs7 = 0;
            this.jxjcForm.jjZs8 = 0;
            this.jxjcForm.jjZs9 = 0;
            this.jxjcForm.jjZs10 = 0;
            this.jxjcForm.jjBz = '';
            this.kcsxholder = '请先选择课程';
            this.kcsxDisabled = true;

            this.$nextTick(function () {
                if (this.$refs['jxjcForm'] != undefined) {
                    this.$refs['jxjcForm'].clearValidate();
                }
            });
            this.jxjcTitle = '';
            this.jxjcDialogVisible = false;
        },
        closeCompareJxjcDialog() {
            this.closeJxjcDialog();
            this.jxjcCompareDialogVisible = false;
        },
        closeJxjcInfoDialog() {
            this.showSchemeDialogVisivle = false;
        },
        saveJxjcbg(type) {
            this.formSubmiting = true;
            this.$refs['jxjcForm'].validate((valid) => {
                if (valid) {
                    if (this.jxjcTitle == "添加教学进程") {
                        this.editJxjcForm[0].jjBglx = "1";

                    }

                    if (this.jxjcTitle == "修改教学进程") {
                        this.editJxjcForm[0].jjBglx = "2";
                        if (this.editJxjcForm[0].jjJxjcbh == '') {
                            this.$message({
                                title: '提示',
                                message: '请选择原课程！',
                                type: 'warning',
                                duration: 2000,
                            });
                            return;
                        }
                    }

                    if (this.jxjcTitle == "删除教学进程") {
                        this.editJxjcForm[0].jjBglx = "3";
                    }

                    this.editJxjcForm[0].jjPyfabh = this.selectRowData.jpBh;
                    this.editJxjcForm[0].type = type;

                    this.$api.teachingManage.teachingScheme.saveJxjcbg({
                        data: this.editJxjcForm[0],
                    }).then((response) => {
                        let state = response.data.data.state;
                        let msg = response.data.data.msg;

                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: msg ? msg : "保存成功",
                                type: "success",
                                duration: 1500,
                            });

                            this.currentPage_editScheme = 1;
                            this.limit_editScheme = 10;
                            this.queryJxjcbgList();
                            this.loadInfo(this.id);
                            this.closeJxjcDialog();
                        } else {
                            this.$notify({
                                title: "失败",
                                message: msg ? msg : '保存失败',
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch((error) => {
                        this.$notify({
                            title: "错误",
                            message: error,
                            type: "error",
                            duration: 3000,
                        });
                    });
                    this.formSubmiting = false;
                }
            });
            this.formSubmiting = false;
        },
        submitJxjcbg() {
            confirmMsg('提交后将无法修改当前教学进程变更信息，是否继续？').then(() => {
                this.saveJxjcbg("submit");
            });
        },
        formatterNumHour(term, week) {
            let str = "";
            if (week == "0" || week == "") {
                if (term == "0" || term == "") {
                    str = "";
                } else {
                    str = term;
                }
            } else {
                if (term == "0" || term == "") {
                    str = "";
                } else {
                    str = term + " / " + week;
                }
            }
            return str;
        },
        handleExamTypeChange(scope) {
            let examTypeCode = scope.row.examType;
            let examTypeName = '';
            for (let i = 0; i < this.examType.length; i++) {
                if (examTypeCode === this.examType[i].comboValue) {
                    examTypeName = this.examType[i].comboName;
                    break;
                }
            }
            scope.row.examTypeName = examTypeName;
        },
        handleMajorcoreChange(scope) {
            let majorcoreCode = scope.row.isMajorcore;
            let majorcoreName = '';
            for (let i = 0; i < this.sfzt.length; i++) {
                if (majorcoreCode === this.sfzt[i].comboValue) {
                    majorcoreName = this.sfzt[i].comboName;
                    break;
                }
            }
            scope.row.isMajorcoreName = majorcoreName;
        },
        handleCertificateChange(scope) {
            let certificateCode = scope.row.isCertificate;
            let certificateName = '';
            for (let i = 0; i < this.sfzt.length; i++) {
                if (certificateCode === this.sfzt[i].comboValue) {
                    certificateName = this.sfzt[i].comboName;
                    break;
                }
            }
            scope.row.isCertificateName = certificateName;
        },
        //继承
        inhertZYK() {
            this.jcyear = [];
            for (let i = 0; i < this.year.length; i++) {
                if (parseInt(this.year[i].comboValue, 10) < parseInt(this.ksnf, 10)) {
                    this.jcyear.push(this.year[i]);
                }
            }
            this.inheritCourseDialog = true;
        },
        closeInheritCourseDialog() {
            this.inheritCourseDialog = false;
            this.inheritForm.year = '';
        },
        inheritCourseSubmit() {
            if (this.inheritForm.year == null || this.inheritForm.year == '') {
                this.$message({
                    type: 'warning',
                    message: '被继承学年不能为空'
                });
                return;
            }
            confirmMsg('继承专业课前将删除本学年已存在的专业课信息，是否确定？').then(() => {
                this.inheritCourseConfirm();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        inheritCourseConfirm() {
            this.showLoadingMask("专业课信息生成中，请稍候");

            const paramMap = {
                'year': this.inheritForm.year,
                'qxxn': this.ksnf,
                'zydm': this.zydm,
                'pyfabh': this.selectRowData.jpBh,
            }
            this.$api.teachingManage.teachingScheme.inheritCourseConfirm({
                data: paramMap
            }).then(response => {
                let state = response.data.data.state;
                let msg = response.data.data.msg;

                if (state == 'Success') {
                    this.$notify({
                        title: "成功",
                        message: msg ? msg : "保存成功",
                        type: "success",
                        duration: 1500,
                    });

                    //this.queCourseList();
                    this.inheritCourseDialog = false;
                } else {
                    this.$notify({
                        title: "失败",
                        message: msg ? msg : '保存失败',
                        type: "error",
                        duration: 3000,
                    });
                }
                this.closeLoadingMask();
            }).catch(error => {
                this.$notify({
                    title: "错误",
                    message: error,
                    type: "error",
                    duration: 3000,
                });
                this.closeLoadingMask();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
body .el-scrollbar__wrap {
    overflow-x: hidden;
}

.scrollArea /deep/ .el-scrollbar {
    .is-vertical {
        width: 15px;
    }
}

.top-title {
    text-align: center;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    font-weight: bold;
}

.maskStyle {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: none;
    background-color: #000000;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    opacity: 0.6;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
}

.maskFont {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    width: 230px;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -10px;
    margin-left: -115px;
}

.importTips {
    margin-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
}

.errorDiv {
    height: 400px;
    overflow: auto;
}

.elrowStyle {
    display: flex;
    flex-wrap: nowrap;
}

.elrowStyle /deep/ .el-table .cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
}

.el-edit /deep/ .el-input-group__append, .el-input-group__prepend {
    padding: 0 5px !important;
}

.el-edit /deep/ .el-input__inner {
    padding: 0 10px !important;
}
</style>
<style>
.teachingSchemeSetDialog .el-dialog__body {
    padding: 0 20px 10px 20px;
}

.teachingSchemeSetDialog .el-dialog__footer {
    padding: 10px 20px 10px 20px;
}
</style>



// WEBPACK FOOTER //
// teachingScheme.vue?a2d80c44